import { useEffect, useState, useRef, useCallback, useContext } from "react";
import { FiCalendar, FiArrowLeft, FiX, FiCheck, FiTag } from "react-icons/fi";
import { HiArrowSmLeft } from "react-icons/hi";
import { MdPayment } from "react-icons/md";
import { FaFileInvoice } from "react-icons/fa";
import { httpService } from "../../services/httpService";
import { tokenDecode } from "../../utils/helper";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import PetServiceCategoryDrawer from "./PetServiceCategoryDrawer";
import AppointmentHistoryDrawer from "../Calendar/BigCalendar/appointmentcalendar/AppointmentHistoryDrawer";
import BoardingHistoryDrawer from "../Calendar/BigCalendar/bookingcalendar/BoardingHistoryDrawer";
import { TokenContext } from "../../context/TokenContext";
import EnquiryListDrawer from "../Calendar/EnquiryListDrawer";
import EditEnquiry from "../Calendar/EditEnquiry";
import { useAllowPastBooking, isBeforeMinBookingDate, pastBookingBlockedMessage } from "../../hooks/useAllowPastBooking";
import SelectAddOnsDrawer from "./SelectAddOnsDrawer";
import {
  PaymentStatusBadge,
  StatusUtils,
} from "../../components/common/StatusComponents";
import OrderNumberBadge from "../../components/common/OrderNumberBadge";
import TotalsSummary from "../common/TotalsSummary";
import PetServiceList from "../common/PetServiceList";
import ClientCard from "../common/ClientCard";
import AddPetsServicesButton from "../common/AddPetsAndServiceButton";
import NotesSection from "../common/NotesSection";
import PaymentAndInvoice from "../common/PaymentAndInvoice";
import OtherChargesDrawer from "../../components/common/OtherChargesDrawer";
import ProductCatalog from "../../components/common/ProductCatalog";
import {useProfile} from "../../context/ProfileContext";
import AdjustmentAmountCard from "../../components/common/AdjustmentAmountCard";

const getOrderCategories = (orderItems = []) => {
  const set = new Set();
  orderItems.forEach((it) => {
    const t = String(it.item_type || it.type || "").toLowerCase();
    if (!t) return;
    if (t === "product") set.add("POS");
    else if (t === "boarding" || t === "day_care") set.add("Boarding");
    else if (t === "grooming") set.add("Grooming");
    else if (t === "vet" || t === "vet_clinic") set.add("Vet");
  });
  return Array.from(set);
};

const isAnyOrderCategoryEnabled = (categories = [], orderCategories = []) => {
  if (!orderCategories.length) return true;
  return orderCategories.some((cat) => {
    const cfg = (categories || []).find(
      (c) => (c.name || "").toLowerCase() === cat.toLowerCase(),
    );
    return !cfg || cfg.enabled === true;
  });
};

const BookingDetailsDrawer = ({
  isOpen = false,
  onClose = () => {},
  orderId = null,
  mode = "details", // 'details' | 'update'
  refreshClients,
  refId = null, // Add ref_id parameter to determine source (queue vs regular)
  sourceType = "regular", // 'queue' | 'regular' to determine API source
  draggedBookingData = null, // New prop for drag and drop data
  ref_id = null,
}) => {
  const { minDate, allowPastBooking, maxPastDays } = useAllowPastBooking();
  const [orderData, setOrderData] = useState(null); // full order payload
  const [clientData, setClientData] = useState(null); // client payload
  const [loading, setLoading] = useState(false);
  const [showPetServiceDrawer, setShowPetServiceDrawer] = useState(false);
  const [itemData, setItemData] = useState([]);
  const [drawerEditMode, setDrawerEditMode] = useState(false);
  const [appointmentList, setAppointmentList] = useState([]);
  // Employees list for assigning staff when updating schedule
  const [employees, setEmployees] = useState([]);

  const pendingUpdateRef = useRef(null);
  const [rooms, setRooms] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [showHistoryDrawer, setShowHistoryDrawer] = useState(false);

  const [showPaymentSection, setShowPaymentSection] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({
    paymentType: "", // 'full', 'partial'
    amount: "",
    method: "", // 'cash', 'upi', 'credit', 'cheque', 'bank'
    reference: "",
    notes: "",
  });
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [showEnquiryDrawer, setShowEnquiryDrawer] = useState(false);
  const [enquiryData, setEnquiryData] = useState([]);
  const [loadingEnquiries, setLoadingEnquiries] = useState(false);
  const [expandedEnquiry, setExpandedEnquiry] = useState(null);
  const [showEnquiryPaymentSection, setShowEnquiryPaymentSection] =
    useState(false);
  const [selectedEnquiryForPayment, setSelectedEnquiryForPayment] =
    useState(null);
  const { decodedData } = useContext(TokenContext);
 
const { profileData, fetchProfile } = useProfile() || {};
const systemSettings = profileData?.systemSettings;
  const [isCancelledOrCompleted, setIsCancelledOrCompleted] = useState(false);
  const [notes, setNotes] = useState("");

  // Ref to track current orderData for setTimeout callbacks
  const orderDataRef = useRef(null);
  const [productList, setProductList] = useState([]);

  // Boarding price calculation states for Update Boarding Schedule
  const [boardingPriceData, setBoardingPriceData] = useState({
    price: 0,
    taxAmount: 0,
    discount: 0,
    subtotal: 0,
    total: 0,
  });
  const [isCalculatingPrice, setIsCalculatingPrice] = useState(false);
  const [orderDiscount, setOrderDiscount] = useState(0);

  // Price calculation de-dupe controls (same as BoardingDrawer)
  const priceCalcLastParamsRef = useRef(null);
  const priceCalcTimerRef = useRef(null);
  const priceCalcInFlightRef = useRef(false);
  // Add new ref to track if we're in drag-and-drop mode
  const isDragDropModeRef = useRef(false);
  // Add ref to track previous values for change detection
  const previousBoardingValuesRef = useRef({});
  // Add ref to track toast debouncing
  const toastTimerRef = useRef(null);

  const [discount, setDiscount] = useState({
    type: "percentage", // percentage | fixed
    value: 0,
    amount: 0,
  });

  const [totalSummary, setTotalSummary] = useState({
    amount_before_discount: 0,
    gst_after_discount: 0,
    discount_amount: 0,
    total: 0,
    discountAmount: 0,
    discountedGST: 0,
    total_paid_amount: 0,
    amountBeforeDiscount: 0,
    adjusted_amount: 0,
  });

  const [editEnquiryData, setEditEnquiryData] = useState([]);
  const [showEditEnquiryDrawer, setShowEditEnquiryDrawer] = useState(false);

  //Addons States
  const [isAddonsDrawerOpen, setIsAddonsDrawerOpen] = useState(false);
  const [addonsServiceCategoryId, setAddonsServiceCategoryId] = useState(null);
  const [addonsPetType, setAddonsPetType] = useState("Both");
  const [addonsPetTypeId, setAddonsPetTypeId] = useState(null);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [serviceTypeName, setServiceTypeName] = useState("");
  const [conflictingAppointments, setConflictingAppointments] = useState([]);

  //products States
  const [isProductsDrawerOpen, setIsProductsDrawerOpen] = useState(false);
  const [productsServiceCategoryId, setProductsServiceCategoryId] =
    useState(null);
  // const [selectedProducts, setSelectedProducts] = useState([]);

  // Add these states with other states (around line 130-140)
  const [isOtherChargesDrawerOpen, setIsOtherChargesDrawerOpen] =
    useState(false);
  const [otherCharges, setOtherCharges] = useState([]);
  const [otherChargesSelectedIndex, setOtherChargesSelectedIndex] =
    useState(null);
  const [itemRefId, setItemRefId] = useState(null);
  
  const [adjustmentAmount, setAdjustmentAmount] = useState(0);
  const [adjustmentReason, setAdjustmentReason] = useState("");
  const [savingAdjustment, setSavingAdjustment] = useState(false);
  // Sync adjustment input with the order whenever it loads / refreshes
  useEffect(() => {
    if (orderData) {
      setAdjustmentAmount(parseFloat(orderData.adjustment_amount || 0));
      setAdjustmentReason(orderData.adjustment_reason || "");
    }
  }, [orderData?._id, orderData?.adjustment_amount, orderData?.adjustment_reason]);
  const handleSaveAdjustment = async () => {
  if (!orderId || savingAdjustment) return;

  const numericAmount = parseFloat(adjustmentAmount) || 0;
  const originalAmount = parseFloat(
    orderData?.grand_total ?? orderData?.total_amount ?? 0
  );
  const currentAdjustment = parseFloat(orderData?.adjustment_amount || 0);

  // Validations
  if (numericAmount < 0) {
    toast.error("Adjustment cannot be negative");
    return;
  }
  if (numericAmount > originalAmount) {
    toast.error(
      `Adjustment cannot exceed order amount (₹${originalAmount.toFixed(2)})`
    );
    return;
  }
  // No-op if unchanged
  if (numericAmount === currentAdjustment && adjustmentReason === orderData?.adjustment_reason) return;

  try {
    setSavingAdjustment(true);
    const res = await httpService.post(
      "/orderpayment/saveOrderAdjustment",
      {
        order_id: orderId,
        adjustment_amount: numericAmount,
        adjustment_reason: adjustmentReason,
      }
    );

    if (res?.status) {
      toast.success("Adjustment saved successfully!", {
        position: "top-center",
      });
      // Refetch so TotalsSummary + PaymentAndInvoice pick up the new values
      await fetchOrderAndClient();
      if (refreshClients) {
        setTimeout(() => refreshClients(), 100);
      }
    } else {
      throw new Error(res?.message || "Failed to save adjustment");
    }
  } catch (err) {
    console.error("Save adjustment error:", err);
    toast.error(
      err?.response?.data?.message || "Failed to save adjustment",
      { position: "top-center" }
    );
    // Revert input to last known value
    setAdjustmentAmount(parseFloat(orderData?.adjustment_amount || 0));
    setAdjustmentReason(orderData?.adjustment_reason || "");
  } finally {
    setSavingAdjustment(false);
  }
};

  useEffect(() => {
    if (!loading && clientData && orderData) setItemRefId(ref_id);
  }, [ref_id, loading, clientData, orderData]);

  useEffect(() => {
  if (isOpen) {
    fetchProfile?.().catch(() => {});
  }
}, [isOpen]);

  // Simple scroll prevention
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [
    isOpen,
    isProductsDrawerOpen,
    isOtherChargesDrawerOpen,
    isAddonsDrawerOpen,
    showPetServiceDrawer,
    drawerEditMode,
    showPaymentSection,
    showEnquiryPaymentSection,
    showEnquiryDrawer,
  ]);

  // Add handler functions (add with other handler functions)
  const handleOpenOtherChargesDrawer = (appointment, index) => {
    setOtherChargesSelectedIndex(index);
    setOtherCharges(appointment.otherCharges || []);
    setIsOtherChargesDrawerOpen(true);
  };

  const handleCloseOtherCharges = () => {
    setIsOtherChargesDrawerOpen(false);
    setOtherChargesSelectedIndex(null);
    setOtherCharges([]);
  };

  const handleSaveOtherCharges = (updatedOtherCharges) => {
    setIsOtherChargesDrawerOpen(false);
    if (otherChargesSelectedIndex === null) return;

    setAppointmentList((prev) => {
      const updated = [...prev];
      const updatedItem = {
        ...updated[otherChargesSelectedIndex],
        otherCharges: updatedOtherCharges,
      };

      updateItemUsingAPI(
        {
          order_type: orderData?.order_type,
          vendor_client_id: orderData?.vendor_client_id || clientData?._id,
          order_items: [
            buildOrderItemPayload(updatedItem, otherChargesSelectedIndex),
          ],
          order_id: orderId,
        },
        "Other charges updated successfully!",
      );
      updated[otherChargesSelectedIndex] = updatedItem;

      return updated;
    });
  };

  /**
   * Check if an employee is double-booked at the same time within the same order
   * @param {Array} appointments - List of appointments in current order
   * @param {Object} newAppointment - The appointment being added/edited
   * @param {number} editIndex - Index of appointment being edited (-1 for new)
   * @returns {Object} { isValid: boolean, conflictMessage: string }
   */
  const checkEmployeeDoubleBooking = (
    appointments,
    newAppointment,
    editIndex = -1,
  ) => {
    // Skip validation for boarding/daycare (they have different time logic)
    if (
      newAppointment.item_type?.toLowerCase() === "boarding" ||
      newAppointment.item_type?.toLowerCase() === "day_care"
    ) {
      return { isValid: true, conflictMessage: "" };
    }

    // Skip if no employee selected
    if (!newAppointment.technician_id) {
      return { isValid: true, conflictMessage: "" };
    }

    // Skip if no date/time selected
    if (!newAppointment.start_date || !newAppointment.start_time) {
      return { isValid: true, conflictMessage: "" };
    }

    // Check for conflicts with existing appointments in the SAME order
    for (let i = 0; i < appointments.length; i++) {
      const existing = appointments[i];

      // Skip if this is the appointment being edited
      if (editIndex === i) continue;

      // Skip if not a regular appointment
      if (
        existing.item_type?.toLowerCase() === "boarding" ||
        existing.item_type?.toLowerCase() === "day_care"
      ) {
        continue;
      }

      // Skip if no employee assigned
      if (!existing.technician_id) continue;

      // Check if same employee, same date, same time
      if (
        existing.technician_id === newAppointment.technician_id &&
        existing.start_date === newAppointment.start_date &&
        existing.start_time === newAppointment.start_time
      ) {
        return {
          isValid: false,
          conflictMessage: `${existing.employee_name || "Employee"} is already booked at ${existing.start_time} on ${existing.start_date} for ${existing.pet_name}`,
        };
      }
    }

    return { isValid: true, conflictMessage: "" };
  };

  /**
   * Validate all appointments for conflicts
   * @param {Array} appointments - List of all appointments
   * @returns {Object} { isValid: boolean, conflicts: Array }
   */
  const validateAllAppointments = (appointments) => {
    const conflicts = [];

    for (let i = 0; i < appointments.length; i++) {
      const appointment = appointments[i];
      const result = checkEmployeeDoubleBooking(appointments, appointment, i);

      if (!result.isValid) {
        conflicts.push({
          index: i,
          petName: appointment.pet_name,
          conflictMessage: result.conflictMessage,
        });
      }
    }

    return {
      isValid: conflicts.length === 0,
      conflicts,
    };
  };

  // Add this function near the other helper functions (around line 200-250)
  const buildOrderItemPayload = (appointment, index) => {
    // ✅ Ensure products are properly formatted with correct price
    const formattedProducts = (appointment.products || []).map((product) => ({
      ...product,
      // Ensure price is not zero
      price: product.price || product.amount_without_tax || 0,
      unit_price: product.unit_price || 0,
      total_price:
        product.total_price || product.unit_price * (product.quantity || 1),
      gst: product.gst || 0,
      tax_percentage: product.tax_percentage || product.gst_slab || 0,
      amount_without_tax: product.amount_without_tax || 0,
      amount_with_tax: product.amount_with_tax || product.unit_price || 0,
      mrp_price: product.mrp_price || product.sale_price || 0,
    }));

    return {
      ...appointment,
      service_category_type_id:
        appointment.service_category_type_id || appointment.service_type_id,
      pet_size: appointment.pet_size || "",
      pet_breed: appointment.pet_breed || "",
      employee_id: appointment.technician_id,
      price: appointment.unit_price,
      discount: appointment.discount || 0,
      gst: appointment.gst || 0,
      total_price: appointment.total_price || appointment.unit_price,
      addons: appointment.addons || [],
      products: formattedProducts, // Use the formatted products
      otherCharges: appointment.otherCharges || [],
      notes: appointment.notes || "",
      quantity:
        appointment.item_type === "boarding"
          ? Number(appointment?.duration)
          : 1,
    };
  };

  const updateItemUsingAPI = async (payload, successMessage) => {
    try {
      const response = await httpService.post(
        "vendororder/addVendorOrderOrUpdate",
        payload,
      );
      if (response.status) {
        toast.success(successMessage);
        fetchOrderAndClient();
      }
    } catch (err) {
      console.error("Save failed", err);
      toast.error(err.response?.data?.message || "Failed to update Service");
    }
  };

  const handleOpenAddonsDrawer = (item, index) => {
    setAddonsServiceCategoryId(
      item.service_category_type_id || item.service_type_id,
    );
    setAddonsPetType(item.pet_type);
    setAddonsPetTypeId(item.pet_type_id);
    // setSelectedAddons(item.addons || []);
    setSelectedItemIndex(index);
    setIsAddonsDrawerOpen(true);
    setServiceTypeName(item.service_type_name);
  };

  const handleCloseAddons = () => {
    setIsAddonsDrawerOpen(false);
  };
  const handleSaveAddons = (updatedAddons) => {
    setIsAddonsDrawerOpen(false);
    if (!updatedAddons || selectedItemIndex === null) return;

    setAppointmentList((prev) => {
      const updated = [...prev];

      const existingAddons = updated[selectedItemIndex].addons || [];
      // Normalize to array
      const newAddons = Array.isArray(updatedAddons)
        ? updatedAddons
        : [updatedAddons];

      const mergedAddons = [...existingAddons];

      newAddons.forEach((newItem) => {
        const index = mergedAddons.findIndex(
          (item) => item.addon_id === newItem.addon_id,
        );

        if (index !== -1) {
          const quantity =
            (mergedAddons[index].quantity || 0) + (newItem.quantity || 1);
          // Item exists → increment quantity, keep all other fields
          mergedAddons[index] = {
            ...mergedAddons[index], // keep existing fields
            quantity: quantity,
          };
        } else {
          // Item does not exist → push
          mergedAddons.push(newItem);
        }
      });

      const updatedItem = {
        ...updated[selectedItemIndex],
        addons: mergedAddons,
      };

      updateItemUsingAPI(
        {
          order_type: orderData?.order_type,
          vendor_client_id: orderData?.vendor_client_id || clientData?._id,
          order_items: [buildOrderItemPayload(updatedItem, selectedItemIndex)],
          order_id: orderId,
        },
        "Addons updated successfully!",
      );
      updated[selectedItemIndex] = updatedItem;

      const result = updated;
      return result;
    });
  };

  const handleOpenAddProductsDrawer = (item, index) => {
    setProductsServiceCategoryId(
      item.service_category_type_id || item.service_type_id,
    );
    setSelectedItemIndex(index);

    // Convert appointment products to format expected by ProductCatalog
    const initialCart = (item?.products || []).map((product) => ({
      id: product.product_id || product.id,
      name: product.product_name || product.name,
      price: product.unit_price || product.price || 0,
      quantity: product.quantity || 1,
      gst: product.gst || product.gstAmount || 0,
      tax_percentage: product.tax_percentage || 0,
      sku_number: product.sku_number,
      ...product,
    }));

    // setSelectedProducts(initialCart);
    setIsProductsDrawerOpen(true);
    setServiceTypeName(item.service_type_name);
  };

  const handleSaveProducts = (updatedProducts) => {
    setIsProductsDrawerOpen(false);

    if (selectedItemIndex === null) return;

    const roundToTwo = (num) => {
      if (num === null || num === undefined || isNaN(num)) return 0;
      return Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;
    };

    const formattedProducts = updatedProducts.map((product) => {
      // Get values from product (using the correct field names from ProductCatalog)
      const effectivePrice = Number(
        product.sale_price_after_discount ||
          product.effective_sale_price ||
          product.price ||
          0,
      );
      const mrpPrice = Number(
        product.mrp || product.mrp_price || product.sale_price || 0,
      );
      const gstSlab = Number(product.gst_slab || product.tax_percentage || 0);
      const quantity = Number(product.quantity || 1);

      // ✅ CRITICAL: Calculate price without tax
      let priceWithoutTax = effectivePrice;
      let gstAmount = 0;

      if (gstSlab > 0 && effectivePrice > 0) {
        // priceWithoutTax = effectivePrice / (1 + gstSlab/100)
        priceWithoutTax = effectivePrice / (1 + gstSlab / 100);
        gstAmount = effectivePrice - priceWithoutTax;
      }

      return {
        // Preserve all original product data first
        ...product,

        // Core identifiers — these must come AFTER the spread to win
        product_id: product.id || product._id,
        product_name: product.name,

        // Quantity
        quantity: quantity,

        // ✅ CRITICAL: These fields MUST be correct
        unit_price: roundToTwo(effectivePrice),
        price: roundToTwo(priceWithoutTax),
        mrp_price: roundToTwo(mrpPrice),
        sale_price: roundToTwo(mrpPrice),
        total_price: roundToTwo(effectivePrice * quantity),

        // GST fields
        gst: roundToTwo(gstAmount),
        gstAmount: roundToTwo(gstAmount),
        gstAmountAfterDiscount: roundToTwo(gstAmount),
        tax_percentage: gstSlab,
        tax_amount: roundToTwo(gstAmount),

        // Amount breakdowns
        amount_without_tax: roundToTwo(priceWithoutTax),
        amount_with_tax: roundToTwo(effectivePrice),
        amount_before_discount: roundToTwo(mrpPrice),
        amount_after_discount: roundToTwo(effectivePrice),

        // Additional fields
        description: product.description || "",
        sku_number: product.sku_number || "",
        gst_slab: gstSlab,
      };
    });
    setAppointmentList((prev) => {
      const updated = [...prev];
      const existingProducts = updated[selectedItemIndex].products || [];

      // Merge products
      const mergedProducts = [...existingProducts];

      formattedProducts.forEach((newItem) => {
        const existingIndex = mergedProducts.findIndex(
          (item) => item.product_id === newItem.product_id,
        );

        if (existingIndex !== -1) {
          const existing = mergedProducts[existingIndex];
          const newQuantity = existing.quantity + newItem.quantity;

          mergedProducts[existingIndex] = {
            ...newItem,
            quantity: newQuantity,
            total_price: newItem.unit_price * newQuantity,
            amount_without_tax: newItem.amount_without_tax * newQuantity,
          };
        } else {
          // Item does not exist → push
          mergedProducts.push(newItem);
        }
      });

      const updatedItem = {
        ...updated[selectedItemIndex],
        products: mergedProducts,
      };
      const payload = {
        order_type: orderData?.order_type || "offline",
        vendor_client_id: orderData?.vendor_client_id || clientData?._id,
        order_items: [buildOrderItemPayload(updatedItem, selectedItemIndex)],
        order_id: orderId,
      };

      updateItemUsingAPI(payload, "Products updated successfully!");
      updated[selectedItemIndex] = updatedItem;

      return updated;
    });
  };

  // Handle deleting a product from an appointment
  const handleDeleteProductFromAppointment = async (
    appointmentIndex,
    productId,
  ) => {
    Swal.fire({
      title: "Delete Product?",
      text: "Are you sure you want to remove this product?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Store the original products for rollback
        const originalAppointment = appointmentList[appointmentIndex];
        const originalProducts = [...(originalAppointment?.products || [])];

        // Update local state immediately
        setAppointmentList((prev) => {
          const updated = [...prev];
          if (updated[appointmentIndex]?.products) {
            updated[appointmentIndex].products = updated[
              appointmentIndex
            ].products.filter(
              (product) =>
                product.product_id !== productId && product.id !== productId,
            );
          }
          return updated;
        });

        try {
          // Build updated appointment
          const updatedAppointment = {
            ...appointmentList[appointmentIndex],
            products:
              appointmentList[appointmentIndex]?.products?.filter(
                (product) =>
                  product.product_id !== productId && product.id !== productId,
              ) || [],
          };
          await updateItemUsingAPI(
            {
              order_type: orderData?.order_type,
              vendor_client_id: orderData?.vendor_client_id || clientData?._id,
              order_items: [
                buildOrderItemPayload(updatedAppointment, appointmentIndex),
              ],
              order_id: orderId,
            },
            "Product removed successfully!",
          );
        } catch (error) {
          console.error("Failed to delete product:", error);
          // Rollback on error
          setAppointmentList((prev) => {
            const updated = [...prev];
            updated[appointmentIndex].products = originalProducts;
            return updated;
          });
          toast.error("Failed to remove product");
        }
      }
    });
  };
  const handleDecrementProductQuantity = async (
    appointmentIndex,
    productIndex,
  ) => {
    // Store the original appointment for rollback
    const originalAppointment = appointmentList[appointmentIndex];
    const originalProduct = originalAppointment?.products?.[productIndex];

    if (!originalProduct) return;

    // Create updated product with decremented quantity
    const updatedProduct = {
      ...originalProduct,
      quantity: originalProduct.quantity - 1,
    };

    // Update local state immediately
    setAppointmentList((prev) => {
      const updated = [...prev];
      if (updated[appointmentIndex]?.products) {
        const updatedProducts = [...updated[appointmentIndex].products];
        if (updatedProduct.quantity > 0) {
          // Update the product with new quantity
          updatedProducts[productIndex] = updatedProduct;
        } else {
          // If quantity becomes 0, remove the product
          updatedProducts.splice(productIndex, 1);
        }
        updated[appointmentIndex].products = updatedProducts;
      }
      return updated;
    });

    try {
      // Build updated appointment
      const updatedAppointment = {
        ...appointmentList[appointmentIndex],
        products:
          appointmentList[appointmentIndex]?.products?.map((product, idx) =>
            idx === productIndex ? updatedProduct : product,
          ) || [],
      };

      // If quantity becomes 0, filter out the product
      if (updatedProduct.quantity === 0) {
        updatedAppointment.products = updatedAppointment.products.filter(
          (_, idx) => idx !== productIndex,
        );
      }

      await updateItemUsingAPI(
        {
          order_type: orderData?.order_type,
          vendor_client_id: orderData?.vendor_client_id || clientData?._id,
          order_items: [
            buildOrderItemPayload(updatedAppointment, appointmentIndex),
          ],
          order_id: orderId,
        },
        "Product quantity decreased successfully!",
      );
    } catch (error) {
      console.error("Failed to decrement product quantity:", error);
      // Rollback on error
      setAppointmentList((prev) => {
        const updated = [...prev];
        updated[appointmentIndex] = {
          ...originalAppointment,
          products: [...(originalAppointment?.products || [])],
        };
        return updated;
      });
      toast.error("Failed to update product quantity");
    }
  };
  const handleIncrementProductQuantity = async (
    appointmentIndex,
    productIndex,
  ) => {
    // Store original for rollback
    const originalAppointment = appointmentList[appointmentIndex];
    const originalProduct = originalAppointment?.products?.[productIndex];

    if (!originalProduct) return;

    const updatedProduct = {
      ...originalProduct,
      quantity: (originalProduct.quantity || 1) + 1,
    };

    // ✅ Update UI instantly
    setAppointmentList((prev) => {
      const updated = [...prev];
      if (updated[appointmentIndex]?.products) {
        const updatedProducts = [...updated[appointmentIndex].products];
        updatedProducts[productIndex] = updatedProduct;
        updated[appointmentIndex].products = updatedProducts;
      }
      return updated;
    });

    try {
      const updatedAppointment = {
        ...appointmentList[appointmentIndex],
        products:
          appointmentList[appointmentIndex]?.products?.map((p, idx) =>
            idx === productIndex ? updatedProduct : p,
          ) || [],
      };

      await updateItemUsingAPI(
        {
          order_type: orderData?.order_type,
          vendor_client_id: orderData?.vendor_client_id || clientData?._id,
          order_items: [
            buildOrderItemPayload(updatedAppointment, appointmentIndex),
          ],
          order_id: orderId,
        },
        "Product quantity increased successfully!",
      );
    } catch (error) {
      console.error("Failed to increment product quantity:", error);

      // rollback
      setAppointmentList((prev) => {
        const updated = [...prev];
        updated[appointmentIndex] = {
          ...originalAppointment,
          products: [...(originalAppointment?.products || [])],
        };
        return updated;
      });

      toast.error("Failed to update product quantity");
    }
  };

  // Handle deleting an addon from an appointment
  const handleDeleteAddonFromAppointment = async (
    appointmentIndex,
    addonIndex,
  ) => {
    Swal.fire({
      title: "Delete Addon?",
      text: "Are you sure you want to remove this addon?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Store the original addons for rollback
        const originalAppointment = appointmentList[appointmentIndex];
        const originalAddons = [...(originalAppointment?.addons || [])];

        // Update local state immediately
        setAppointmentList((prev) => {
          const updated = [...prev];
          if (updated[appointmentIndex]?.addons) {
            updated[appointmentIndex].addons = updated[
              appointmentIndex
            ].addons.filter((_, idx) => idx !== addonIndex);
          }
          return updated;
        });

        try {
          // Build updated appointment
          const updatedAppointment = {
            ...appointmentList[appointmentIndex],
            addons:
              appointmentList[appointmentIndex]?.addons?.filter(
                (_, idx) => idx !== addonIndex,
              ) || [],
          };
          await updateItemUsingAPI(
            {
              order_type: orderData?.order_type,
              vendor_client_id: orderData?.vendor_client_id || clientData?._id,
              order_items: [
                buildOrderItemPayload(updatedAppointment, appointmentIndex),
              ],
              order_id: orderId,
            },
            "Addon removed successfully!",
          );
        } catch (error) {
          console.error("Failed to delete addon:", error);
          // Rollback on error
          setAppointmentList((prev) => {
            const updated = [...prev];
            updated[appointmentIndex].addons = originalAddons;
            return updated;
          });
          toast.error("Failed to remove addon");
        }
      }
    });
  };
  const handleDecrementAddonQuantity = async (appointmentIndex, addonIndex) => {
    // Store the original addon for rollback
    const originalAppointment = appointmentList[appointmentIndex];
    const originalAddon = originalAppointment?.addons?.[addonIndex];

    if (!originalAddon) return;

    // Create updated addon with decremented quantity
    const updatedAddon = {
      ...originalAddon,
      quantity: originalAddon.quantity - 1,
    };

    // Update local state immediately
    setAppointmentList((prev) => {
      const updated = [...prev];
      if (updated[appointmentIndex]?.addons) {
        const updatedAddons = [...updated[appointmentIndex].addons];
        if (updatedAddon.quantity > 0) {
          // Update the addon with new quantity
          updatedAddons[addonIndex] = updatedAddon;
        } else {
          // If quantity becomes 0, remove the addon
          updatedAddons.splice(addonIndex, 1);
        }
        updated[appointmentIndex].addons = updatedAddons;
      }
      return updated;
    });

    try {
      // Build updated appointment
      const updatedAppointment = {
        ...appointmentList[appointmentIndex],
        addons:
          appointmentList[appointmentIndex]?.addons?.map((addon, idx) =>
            idx === addonIndex ? updatedAddon : addon,
          ) || [],
      };

      // If quantity becomes 0, filter out the addon
      if (updatedAddon.quantity === 0) {
        updatedAppointment.addons = updatedAppointment.addons.filter(
          (_, idx) => idx !== addonIndex,
        );
      }

      await updateItemUsingAPI(
        {
          order_type: orderData?.order_type,
          vendor_client_id: orderData?.vendor_client_id || clientData?._id,
          order_items: [
            buildOrderItemPayload(updatedAppointment, appointmentIndex),
          ],
          order_id: orderId,
        },
        "Addon quantity decreased successfully!",
      );
    } catch (error) {
      console.error("Failed to decrement addon quantity:", error);
      // Rollback on error
      setAppointmentList((prev) => {
        const updated = [...prev];
        updated[appointmentIndex] = {
          ...originalAppointment,
          addons: [...(originalAppointment?.addons || [])],
        };
        return updated;
      });
      toast.error("Failed to update addon quantity");
    }
  };

  // Handle deleting an other charge from an appointment
  const handleDeleteOtherChargeFromAppointment = async (
    appointmentIndex,
    chargeIndex,
  ) => {
    Swal.fire({
      title: "Delete Other Charge?",
      text: "Are you sure you want to remove this other charge?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Store the original otherCharges for rollback
        const originalAppointment = appointmentList[appointmentIndex];
        const originalCharges = [...(originalAppointment?.otherCharges || [])];

        // Update local state immediately
        setAppointmentList((prev) => {
          const updated = [...prev];
          if (updated[appointmentIndex]?.otherCharges) {
            updated[appointmentIndex].otherCharges = updated[
              appointmentIndex
            ].otherCharges.filter((_, idx) => idx !== chargeIndex);
          }
          return updated;
        });

        try {
          // Build updated appointment
          const updatedAppointment = {
            ...appointmentList[appointmentIndex],
            otherCharges:
              appointmentList[appointmentIndex]?.otherCharges?.filter(
                (_, idx) => idx !== chargeIndex,
              ) || [],
          };
          await updateItemUsingAPI(
            {
              order_type: orderData?.order_type,
              vendor_client_id: orderData?.vendor_client_id || clientData?._id,
              order_items: [
                buildOrderItemPayload(updatedAppointment, appointmentIndex),
              ],
              order_id: orderId,
            },
            "Other charge removed successfully!",
          );
        } catch (error) {
          console.error("Failed to delete other charge:", error);
          // Rollback on error
          setAppointmentList((prev) => {
            const updated = [...prev];
            updated[appointmentIndex].otherCharges = originalCharges;
            return updated;
          });
          toast.error("Failed to remove other charge");
        }
      }
    });
  };

  // Calculate total for an appointment's products
  const calculateAppointmentProductsTotal = (products) => {
    return (
      products?.reduce((total, product) => {
        const price = product.unit_price || product.price || 0;
        const quantity = product.quantity || 1;
        return total + price * quantity;
      }, 0) || 0
    );
  };

  const handleEditEnquiryDrawer = (enquiry) => {
    setShowEditEnquiryDrawer(true);
    setEditEnquiryData(enquiry);
  };

  // Handle product quantity change in enquiry (exact same logic as BookingDetailsDrawer)
  const handleProductQuantityChanges = (item, delta, enquiry) => {
    // Use quantity_available if available, otherwise use original_quantity_available as fallback
    // original_quantity_available preserves the original limit from API response
    const availableQuantity =
      item.quantity_available ||
      item.product_details?.quantity_available ||
      item.original_quantity_available ||
      999;
    const currentQuantity = item.quantity || 1;
    const newQuantity = currentQuantity + delta;

    // If quantity drops to zero or below, don't allow
    if (newQuantity <= 0) {
      toast.warn("Quantity cannot be less than 1", {
        position: "top-center",
      });
      return;
    }

    // Update the enquiry data (same pattern as BookingDetailsDrawer)
    setEnquiryData((prev) =>
      prev.map((e) => {
        if (e._id === enquiry._id) {
          return {
            ...e,
            items: e.items.map((i) => {
              if (i._id === item._id) {
                let finalQuantity = newQuantity;
                let finalTotalPrice =
                  parseFloat(i.price || i.unit_price || 0) * newQuantity;

                // If quantity exceeds available, set to available quantity (same as BookingDetailsDrawer)
                if (newQuantity > availableQuantity) {
                  toast.warn(`Only ${availableQuantity} items available`);
                  finalQuantity = availableQuantity;
                  finalTotalPrice =
                    parseFloat(i.price || i.unit_price || 0) *
                    availableQuantity;
                }

                return {
                  ...i,
                  quantity: finalQuantity,
                  total_price: finalTotalPrice,
                };
              }
              return i;
            }),
          };
        }
        return e;
      }),
    );
  };

  // Handle product quantity input in enquiry (like in BookingDetailsDrawer)
  const handleProductQuantityInputs = (item, value, enquiry) => {
    let qty = parseInt(value, 10);
    if (isNaN(qty) || qty < 1) {
      qty = 1;
    }

    // Use quantity_available if available, otherwise use original_quantity_available as fallback
    // original_quantity_available preserves the original limit from API response
    const maxQuantity =
      item.quantity_available ||
      item.product_details?.quantity_available ||
      item.original_quantity_available ||
      999;
    if (qty > maxQuantity) {
      toast.warn(`Only ${maxQuantity} items available`, {
        position: "top-center",
      });
      qty = maxQuantity;
    }

    // Update the enquiry data with new quantity
    setEnquiryData((prev) =>
      prev.map((e) => {
        if (e._id === enquiry._id) {
          return {
            ...e,
            items: e.items.map((i) => {
              if (i._id === item._id) {
                const updatedItem = {
                  ...i,
                  quantity: qty,
                  total_price: parseFloat(i.price || i.unit_price || 0) * qty,
                };
                return updatedItem;
              }
              return i;
            }),
          };
        }
        return e;
      }),
    );
  };

  useEffect(() => {
    // Update ref to track current orderData
    orderDataRef.current = orderData;
  }, [orderData]);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (pendingUpdateRef.current) {
        pendingUpdateRef.current = false;
      }
      if (priceCalcTimerRef.current) {
        clearTimeout(priceCalcTimerRef.current);
      }
      if (toastTimerRef.current) {
        clearTimeout(toastTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!isOpen) {
      setProductList([]);
      // Reset boarding price data when drawer closes
      setBoardingPriceData({
        price: 0,
        taxAmount: 0,
        discount: 0,
        subtotal: 0,
        total: 0,
      });
      setIsCalculatingPrice(false);
      // Reset drag-drop mode when drawer closes
      isDragDropModeRef.current = false;
    }
  }, [isOpen]);

  // Handle dragged booking data for update mode
  useEffect(() => {
    if (!(mode === "update" && draggedBookingData && appointmentList?.length))
      return;

    isDragDropModeRef.current = true;

    const toLocalDateString = (val) => {
      try {
        if (val instanceof Date) {
          const y = val.getFullYear();
          const m = String(val.getMonth() + 1).padStart(2, "0");
          const d = String(val.getDate()).padStart(2, "0");
          return `${y}-${m}-${d}`;
        }
        if (typeof val === "string") return val;
      } catch (_) {}
      return val;
    };

    const updated = [...appointmentList];
    let changed = false;

    const boardingIndex = updated.findIndex(
      (app) => (app.item_type || "").toLowerCase() === "boarding",
    );
    if (boardingIndex !== -1) {
      const orig = updated[boardingIndex];
      const next = {
        ...orig,
        start_date: toLocalDateString(draggedBookingData.startDate),
        end_date: toLocalDateString(draggedBookingData.endDate),
        room_type_id: draggedBookingData.roomId,
        room_id: draggedBookingData.bedId,
        room_name: draggedBookingData.roomName,
        room_number: draggedBookingData.roomNumber,
        vendor_pet_id: orig.vendor_pet_id || orig.pet_id,
        pet_name: orig.pet_name,
        status: orig.status || draggedBookingData.status,
      };

      if (JSON.stringify(orig) !== JSON.stringify(next)) {
        updated[boardingIndex] = next;
        changed = true;
      }
    }

    const regularIndex = updated.findIndex(
      (app) => (app.item_type || "").toLowerCase() !== "boarding",
    );
    if (regularIndex !== -1) {
      const orig = updated[regularIndex];
      const next = {
        ...orig,
        start_date: toLocalDateString(draggedBookingData.startDate),
        // Force set start_time from draggedBookingData if present (don't silently fallback)
        start_time: draggedBookingData.startTime ?? orig.start_time,
        vendor_pet_id: orig.vendor_pet_id || orig.pet_id,
        pet_name: orig.pet_name,
        status: orig.status || draggedBookingData.status,
      };

      if (JSON.stringify(orig) !== JSON.stringify(next)) {
        updated[regularIndex] = next;
        changed = true;
      }
    }

    if (changed) {
      setAppointmentList(updated);
    }

    const timer = setTimeout(() => {
      isDragDropModeRef.current = false;
    }, 1000);

    return () => clearTimeout(timer);
  }, [mode, draggedBookingData, appointmentList]); // appointmentList included

  // Calculate totals
  // const calculateTotals = () => {
  //   let subtotal = Number(0);
  //   let totalGst = Number(0);
  //   const isProductOnlyOrder =
  //     appointmentList.length === 0 && productList.length > 0;

  //   // Calculate for appointments
  //   appointmentList.forEach((appointment) => {
  //     let basePrice;
  //     if (
  //       appointment.amount_without_tax &&
  //       appointment.amount_without_tax > 0
  //     ) {
  //       basePrice = parseFloat(appointment.amount_without_tax || 0);
  //     } else {
  //       const unitPrice = parseFloat(appointment.unit_price || 0);
  //       const quantity = parseFloat(appointment.quantity || 1);
  //       basePrice = unitPrice * quantity;
  //     }

  //     const addonTotal =
  //       appointment.addons?.reduce((sum, addon) => {
  //         let addonPrice = addon.addon_price || 0;
  //         if (addon?.quantity && addon?.quantity > 1)
  //           addonPrice = addonPrice * addon.quantity;
  //         return sum + parseFloat(addonPrice);
  //       }, 0) || 0;

  //     let finalProductsTax = 0;
  //     const productTotal =
  //       appointment.products?.reduce((sum, product) => {
  //         finalProductsTax += product.final_tax * product.quantity;
  //         return (
  //           sum +
  //           parseFloat(product.final_price || 0) *
  //             parseFloat(product.quantity || 1)
  //         );
  //       }, 0) || 0;

  //     const otherChargesTotal =
  //       appointment.otherCharges?.reduce((sum, charge) => {
  //         return sum + parseFloat(charge.amount || 0);
  //       }, 0) || 0;

  //     const gstAmount =
  //       parseFloat(appointment.tax_amount || appointment.gst || 0) +
  //       finalProductsTax;

  //     subtotal +=
  //       basePrice +
  //       addonTotal +
  //       productTotal +
  //       otherChargesTotal -
  //       finalProductsTax;
  //     totalGst += gstAmount;
  //   });

  //   // Calculate for products
  //   productList.forEach((product) => {
  //     const gstAmount = parseFloat(
  //       product.tax_amount || product.gstAmount || 0,
  //     );
  //     let basePrice;

  //     if (isProductOnlyOrder) {
  //       // ✅ For POS: unit_price is the MRP (incl. GST)
  //       // Store gross (MRP) in subtotal temporarily, we'll split later
  //       const sellingPrice = parseFloat(
  //         product.unit_price || product.price || 0,
  //       );
  //       const quantity = parseFloat(product.quantity || 1);
  //       const lineTotal = sellingPrice * quantity; // 200 (MRP incl. GST)

  //       // Reverse GST to get base
  //       const taxPct = parseFloat(product.tax_percentage || 0);
  //       const base = taxPct > 0 ? lineTotal / (1 + taxPct / 100) : lineTotal;
  //       const gst = lineTotal - base;

  //       subtotal += base; // 190.48 (pre-discount excl. GST)
  //       totalGst += gst; // 9.52  (pre-discount GST)
  //     } else if (product.amount_without_tax && product.amount_without_tax > 0) {
  //       basePrice = parseFloat(product.amount_without_tax || 0);
  //       subtotal += basePrice;
  //       totalGst += gstAmount;
  //     } else {
  //       const unitPrice = parseFloat(product.unit_price || 0);
  //       const quantity = parseFloat(product.quantity || 1);
  //       basePrice = unitPrice * quantity;
  //       subtotal += basePrice;
  //       totalGst += gstAmount;
  //     }
  //   });

  //   // ✅ gross = subtotal + totalGst (= MRP = 200 for POS)
  //   const grossAmount = subtotal + totalGst;

  //   // Apply order-level discount
  //   let discountValue = discount.value;
  //   if (discount.type === "percentage" && discountValue > 100)
  //     discountValue = 100;

  //   let discountAmount;

  //   if (isProductOnlyOrder) {
  //     // ✅ For POS: discount is on gross (MRP incl. GST)
  //     if (discount.type === "percentage") {
  //       discountAmount = (grossAmount * discountValue) / 100; // 200 * 10% = 20
  //     } else {
  //       discountAmount = discountValue;
  //     }
  //     discountAmount = Math.min(discountAmount, grossAmount);
  //   } else {
  //     if (discount.type === "percentage") {
  //       discountAmount = (subtotal * discountValue) / 100;
  //     } else {
  //       discountAmount = discountValue;
  //     }
  //     discountAmount = Math.min(discountAmount, subtotal);
  //   }

  //   discountAmount = parseFloat(discountAmount.toFixed(2));

  //   // ✅ Post-discount net amount
  //   const postDiscountNet = grossAmount - discountAmount; // 200 - 20 = 180

  //   // ✅ For POS: extract GST from post-discount net (reverse/inclusive)
  //   let displaySubtotal = subtotal;
  //   let displayGst = totalGst;

  //   if (isProductOnlyOrder && grossAmount > 0) {
  //     // Weighted avg GST rate from pre-discount values
  //     const avgGstRate = subtotal > 0 ? (totalGst / subtotal) * 100 : 0;

  //     if (avgGstRate > 0) {
  //       // Reverse GST from post-discount net
  //       const postDiscountBase = postDiscountNet / (1 + avgGstRate / 100); // 180/1.05 = 171.43
  //       const postDiscountGst = postDiscountNet - postDiscountBase; // 180 - 171.43 = 8.57

  //       displaySubtotal = parseFloat(postDiscountBase.toFixed(2)); // 171.43 ✅
  //       displayGst = parseFloat(postDiscountGst.toFixed(2)); // 8.57  ✅
  //     } else {
  //       // No GST — just split discount proportionally
  //       displaySubtotal = parseFloat(postDiscountNet.toFixed(2));
  //       displayGst = 0;
  //     }
  //   }

  //   // ✅ Final total
  //   let finalTotalAmount;
  //   if (isProductOnlyOrder) {
  //     finalTotalAmount = postDiscountNet; // 180 ✅
  //   } else {
  //     const discountedSubtotal = subtotal - discountAmount;
  //     const totalAmount = Math.max(0, discountedSubtotal + totalGst);
  //     const backendGrandTotal = parseFloat(orderData?.grand_total || 0);
  //     finalTotalAmount =
  //       mode === "details" &&
  //       Number.isFinite(backendGrandTotal) &&
  //       backendGrandTotal > 0
  //         ? backendGrandTotal
  //         : totalAmount;
  //   }

  //   setDiscount((prev) => ({
  //     ...prev,
  //     amount: discountAmount,
  //     value: discountValue,
  //   }));

  //   setTotalSummary({
  //     subtotal: displaySubtotal.toFixed(2), // 171.43 for POS ✅ | base for services
  //     gst: displayGst.toFixed(2), // 8.57 for POS ✅  | gst for services
  //     discount: discountAmount.toFixed(2), // 20 ✅
  //     total: finalTotalAmount.toFixed(2), // 180 ✅
  //     discountAmount,
  //     discountedGST: displayGst.toFixed(2), // 8.57 ✅
  //     total_paid_amount: parseFloat(orderData?.total_paid_amount || 0).toFixed(
  //       2,
  //     ),
  //   });

  //   return {
  //     subtotal: displaySubtotal.toFixed(2),
  //     gst: displayGst.toFixed(2),
  //     discount: discountAmount.toFixed(2),
  //     total: finalTotalAmount.toFixed(2),
  //     discountAmount,
  //     discountedGST: displayGst.toFixed(2),
  //   };
  // };

  const validatePaymentStatus = (order) => {
    // Use calculated totals from appointmentList for consistency
    const calculatedTotals = totalSummary;
    const totalAmount = parseFloat(
      calculatedTotals.total || order?.total_amount || 0,
    );
    const paidAmount = parseFloat(order?.total_paid_amount || 0);

    if (paidAmount >= totalAmount) {
      return "paid";
    } else if (paidAmount > 0) {
      return "partial";
    } else {
      return "unpaid";
    }
  };

  // Determine if the order has already been paid to hide payment actions where necessary
  const validatedPaymentStatus = orderData
    ? validatePaymentStatus(orderData)
    : "";
  // Use backend payment_status if available, otherwise use calculated status
  const finalPaymentStatus =
    orderData?.payment_status || validatedPaymentStatus;
  const isOrderCancelled =
    StatusUtils.toDisplay(orderData?.status) === "Cancel" ||
    orderData?.status === "cancelled";
  const isOrderClosed = StatusUtils.toDisplay(orderData?.status) === "Closed";
  const isAnyAppointmentCancelled = appointmentList.some(
    (app) => StatusUtils.toDisplay(app.status) === "Cancel",
  );
  const isProductOnlyOrder =
    appointmentList.length === 0 && productList.length > 0;
  const totalsOrderData =
    isProductOnlyOrder && orderData
      ? {
          ...orderData,
          amount_without_tax: parseFloat(totalSummary?.subtotal || 0),
        }
      : orderData;

  // Helper to refresh calendar & queue data globally
  const refreshCalendarData = () => {
    if (
      typeof window !== "undefined" &&
      typeof window.refreshAppointmentData === "function"
    ) {
      window.refreshAppointmentData();
    }
  };

  // Fetch enquiry data
  const fetchEnquiryData = async () => {
    if (!clientData?._id) return;

    setLoadingEnquiries(true);
    try {
      const response = await httpService.get("/vendororder/getOrderEnquiries");
      const allEnquiries = response.data || [];
      // ✨ Filter enquiries for the current vendor client only
      const filtered = allEnquiries.filter(
        (enq) => enq.vendor_client?._id === clientData._id,
      );

      // Add original_quantity_available to each item to preserve the original limit
      const processedEnquiries = filtered.map((enquiry) => ({
        ...enquiry,
        items:
          enquiry.items?.map((item) => ({
            ...item,
            original_quantity_available:
              item.quantity_available ||
              item.product_details?.quantity_available ||
              item.quantity ||
              999,
          })) || [],
      }));

      setEnquiryData(processedEnquiries);
    } catch (error) {
      console.error("Error fetching enquiry data:", error);
      toast.error("Failed to load enquiry data");
      setEnquiryData([]);
    } finally {
      setLoadingEnquiries(false);
    }
  };

  const fetchOrderAndClient = async () => {
    if (!isOpen || !orderId) return;
    try {
      setLoading(true);
      // 1) Fetch order by id
      let orderRes;
      orderRes = await httpService.get(
        `/vendororder/getvendororder/${orderId}`,
      );
      const order = orderRes.data;

      // ✅ CRITICAL FIX: Set discount with the correct amount
      setDiscount({
        type: order.discount_type,
        value: order.discount_value,
        amount: order.discount_amount, // This should be 40
      });

      // ✅ Set totalSummary with correct values
      setTotalSummary({
        amountBeforeDiscount: order.amount_before_discount,
        subtotal: order.sub_total_amount,
        netAmount: order.grand_total - order.gst_after_discount,
        gst: order.total_gst,
        discount: order.discount_amount, // This is 40
        total: order.grand_total,
        discountAmount: order.discount_amount,
        discountedGST: order.gst_after_discount,
        total_paid_amount: order.total_paid_amount,
        amount_after_adjustment: order.amount_after_adjustment,
        adjusted_amount: order.adjustment_amount,
        round_off: order?.round_off || 0,
        total_discount: order?.final_discount || order?.total_discount || 0,
      });

      setOrderData(order);
      setNotes(order?.notes || "");

      const isCancelledOrCompletedStatus = order.order_items.some(
        (item) => item.status === "cancel" || item.status === "completed",
      );
      setIsCancelledOrCompleted(isCancelledOrCompletedStatus);

      if (order.vendor_client_id) {
        try {
          const clientRes = await httpService.get(
            `/vendorclient/getvendorclient/${order.vendor_client_id}`,
          );
          setClientData(clientRes.data);
        } catch (err) {
          console.error("Failed fetching client", err);
        }
      }
    } catch (err) {
      console.error("Failed fetching order", err);
      toast.error("Failed to load booking details");
    } finally {
      setLoading(false);
    }
  };

  /* ------------------------------- Data fetch ------------------------------ */
  useEffect(() => {
    fetchOrderAndClient();
  }, [isOpen, orderId]);

  // Update appointment list with room information when rooms are loaded
  // Replace your existing useEffect that transforms orderData.order_items with this:
  useEffect(() => {
    if (orderData && orderData.order_items) {
      // Separate arrays for appointments and products
      const appointments = [];
      const productItems = [];

      // Helper functions
      const convertFrequencyToUI = (freq) => {
        switch (freq) {
          case "One Time":
            return "one_time";
          case "Weekly":
            return "weekly";
          case "Monthly":
            return "monthly";
          case "Quarterly":
            return "quaterly";
          default:
            return freq.toLowerCase();
        }
      };

      const convertNumberOfTimesToUI = (times) => {
        switch (times) {
          case "Once":
            return "once";
          case "Twice":
            return "twice";
          default:
            return times.toLowerCase();
        }
      };

      // Process each order item
      orderData.order_items.forEach((item, index) => {
        // Get room information if available
        let roomName = null;
        let roomNumber = null;

        if (rooms.length > 0 && item.room_type_id && item.room_id) {
          const roomInfo = getRoomInfo(item.room_type_id, item.room_id);
          roomName = roomInfo.roomName;
          roomNumber = roomInfo.roomNumber;
        }

        if (item.item_type === "product") {
          // Handle PRODUCTS
          const productData = {
            name: item.service_name,
            unit_price: item.unit_price || 0, // Use unit_price from database (400)
            total_price: item.total_price || 0, // 800
            quantity: item.quantity || 1, // 2
            service_id: item?.service_id,
            sku_number: item?.sku_number,
            gstAmount: item.gst || 0, // 5
            tax_amount_before_order_discount:
              item.tax_amount_before_order_discount || 0,
            tax_percentage: item.tax_percentage || 0,
            discount: item.discount || 0,
            amount_without_tax: item.amount_without_tax || 0, // 795
            amount_with_tax: item.amount_with_tax || 0, // 800
            mrp: item.mrp || 0,
            tax_amount: item.tax_amount || 0, // 5
            // Add original ID for reference
            _id: item._id,
            ref_id: item.ref_id,
          };
          productItems.push(productData);
        } else {
          // Handle APPOINTMENTS/BOARDING
          const appointmentData = {
            _id: item._id, // Add the order item's database ID
            id: `${orderData._id}-${index}`,
            discounts: item.discounts,
            price_surcharge: item.price_surcharge || [],
            pet_name: item.pet_name || "Unknown Pet",
            pet_size: item.pet_size || "",
            pet_breed: item.pet_breed || "",
            pet_tags: item.pet_tags || [],
            tax_amount_before_order_discount:
              item.tax_amount_before_order_discount || 0,
            service_name: item.service_name || item.name || "Service",
            service_type_name:
              item.service_type_name || item.service_category_name || " ",
            service_id: item.service_id,
            pet_id: item.vendor_pet_id || item.pet_id,
            pet_type: item.pet_type,
            pet_type_id: item?.pet_type_id,
            vendor_pet_id: item.vendor_pet_id || item.pet_id,
            technician_id: item.technician_id,
            employee_name: item.employee_name || "",
            start_date: item.start_date,
            end_date: item.end_date,
            start_time: item.start_time,
            duration: item.duration || "1 hr",
            unit_price: item.unit_price || 0, // Use unit_price from database (260 for boarding)
            total_price: item.total_price || 0, // 572 for boarding
            quantity: item.quantity || 1, // 2 for boarding
            discount: item.discount || 0,
            discount_amount: item.discount_amount || 0,
            gst: item.gst || 0, // 52 for boarding
            status: item.status || "booked",
            item_type: item.item_type || "grooming",
            addons: item.addons || [],
            products: item.products || [],
            otherCharges: item.otherCharges || [],
            ref_id: item.ref_id,
            service_category_type_id: item.service_category_type_id,
            service_barcode: item.service_barcode,
            room_type_id: item.room_type_id,
            room_id: item.room_id || item.room_number,
            room_number: roomNumber || item.room_number,
            room_name: roomName,
            notes: item.notes || "",
            frequency: convertFrequencyToUI(item.frequency || ""),
            numberOfTimes: convertNumberOfTimesToUI(item.number_of_times || ""),
            // Add amount fields for accurate calculation
            amount_without_tax: item.amount_without_tax || 0, // 520 for boarding
            amount_with_tax: item.amount_with_tax || 0, // 572 for boarding
            tax_amount: item.tax_amount || 0, // 52 for boarding
            tax_percentage: item.tax_percentage || 0, // 10 for boarding
            base_total: item?.base_total,
          };
          appointments.push(appointmentData);
        }
      });
      console.log({appointments});
      setAppointmentList(appointments);
      setProductList(productItems);
    }
  }, [orderData, rooms, orderId]);

  // Auto-open payment section when mode is 'payment'
  useEffect(() => {
    if (isOpen && mode === "payment") {
      setShowPaymentSection(true);
    }
  }, [isOpen, mode]);

  // Fetch enquiry data when enquiry drawer opens
  useEffect(() => {
    if (showEnquiryDrawer && clientData?._id) {
      fetchEnquiryData();
    }
  }, [showEnquiryDrawer, clientData?._id]);

  /* ---------------------------- Fetch employees --------------------------- */
  useEffect(() => {
    if (!isOpen || mode !== "update") return;
    const fetchEmployees = async () => {
      try {
        const res = await httpService.get("/employees/getvendoremployees");
        setEmployees(res.data || []);
      } catch (err) {
        console.error("Failed fetching employees", err);
      }
    };
    fetchEmployees();
  }, [isOpen, mode]);

  /* ---------------------------- Fetch room types --------------------------- */
  useEffect(() => {
    if (!isOpen || mode !== "update") return;
    const fetchRoomTypes = async () => {
      try {
        // Use getRooms API instead of vendorroomtype/getvendorroomtypes
        const res = await httpService.get("/room/getRooms");
        const roomsData = res.data?.data || res.data || [];
        setRoomTypes(roomsData || []);
      } catch (err) {
        console.error("Failed fetching room types", err);
      }
    };
    fetchRoomTypes();
  }, [isOpen, mode]);

  /* ---------------------------- Fetch rooms --------------------------- */
  useEffect(() => {
    if (!isOpen) return;

    const fetchRoomsForBoarding = async () => {
      try {
        // Always fetch all rooms for display purposes
        const res = await httpService.get("/room/getRooms");
        const roomsData = res.data?.data || res.data || [];
        setRooms(roomsData || []);
      } catch (err) {
        console.error("Failed fetching rooms", err);
        setRooms([]);
      }
    };

    fetchRoomsForBoarding();
  }, [isOpen]);

  /* -------------------------- Helper function to get room info ------------------------- */
  const getRoomInfo = (roomTypeId, roomId) => {
    if (!rooms || rooms.length === 0)
      return { roomName: null, roomNumber: null };

    // Find the room type using room_type_id
    let matchedRoom = rooms.find((room) => room._id === roomTypeId);

    if (!matchedRoom) {
      matchedRoom = rooms[0];
    }

    if (!matchedRoom) {
      return { roomName: null, roomNumber: null };
    }

    // Now find the specific bed using room_id
    let matchedBed = null;
    if (roomId && matchedRoom.room_numbers) {
      matchedBed = matchedRoom.room_numbers.find((bed) => bed._id === roomId);
    }

    // If still no match, use the first available bed
    if (
      !matchedBed &&
      matchedRoom.room_numbers &&
      matchedRoom.room_numbers.length > 0
    ) {
      matchedBed = matchedRoom.room_numbers[0];
    }

    const result = {
      roomName: matchedRoom.room_name,
      roomNumber: matchedBed?.room_number || null,
    };
    return result;
  };

  /* -------------------------- Boarding Price Calculation for Update Schedule ------------------------- */

  // Boarding price calculation scheduler - Only call API when specific fields change
  const scheduleBoardingPriceCalculation = useCallback(
    (appointment, index) => {
      // Only calculate for boarding appointments in update mode
      if (
        mode !== "update" ||
        appointment.item_type?.toLowerCase() !== "boarding"
      ) {
        return;
      }

      // Prevent API calls during drag-and-drop operations
      if (isDragDropModeRef.current) {
        return;
      }

      // ✅ CRITICAL FIX: Check if this is a significant change that requires recalculation
      // Only recalculate if dates or room type actually changed
      const currentValues = {
        checkin: appointment.start_date,
        checkout: appointment.end_date,
        roomType: appointment.room_type_id,
      };

      const previousValues = previousBoardingValuesRef.current;

      // If nothing significant changed, don't recalculate
      if (
        previousValues.checkinDate === currentValues.checkin &&
        previousValues.checkoutDate === currentValues.checkout &&
        previousValues.roomTypeId === currentValues.roomType
      ) {
        return;
      }

      // ✅ PRESERVE EXISTING STATUS - Don't reset it
      const currentStatus = appointment.status || "confirmed";

      // Get required fields with fallbacks
      const vendor_pet_id = appointment.vendor_pet_id || appointment.pet_id;
      const clientId = clientData?._id;
      const serviceId = appointment.service_id;
      const roomTypeId = appointment.room_type_id;
      const checkinDate = appointment.start_date;
      const checkoutDate = appointment.end_date;
      // Use individual item's discount instead of total order discount
      const itemDiscount = parseFloat(appointment.discount || 0);

      // Validate required fields before making API call
      if (
        !clientId ||
        !vendor_pet_id ||
        !serviceId ||
        !roomTypeId ||
        !checkinDate ||
        !checkoutDate
      ) {
        return;
      }

      const requestPayload = {
        client_id: clientId,
        pet_id: vendor_pet_id,
        room_service_id: serviceId,
        room_type_id: roomTypeId,
        checkin_date: checkinDate,
        checkout_date: checkoutDate,
      };

      // Check if this is a duplicate request
      const key = JSON.stringify(requestPayload);
      if (
        priceCalcInFlightRef.current &&
        priceCalcLastParamsRef.current === key
      ) {
        return;
      }

      // Clear any existing timer
      if (priceCalcTimerRef.current) {
        clearTimeout(priceCalcTimerRef.current);
      }

      // Debounce the API call
      priceCalcTimerRef.current = setTimeout(async () => {
        try {
          priceCalcInFlightRef.current = true;
          priceCalcLastParamsRef.current = key;
          setIsCalculatingPrice(true);

          // ✅ STEP 1: Get base price calculation (same as QueueTooltip)
          const priceResponse = await httpService.post(
            "/vendorbooking/getPriceCalculation?service_type=boarding",
            requestPayload,
          );

          let basePrice = 0;
          let gstAmount = 0;
          let surchargeDetails = [];

          if (priceResponse && priceResponse.data !== undefined) {
            if (typeof priceResponse.data === "number") {
              basePrice = priceResponse.data;
            } else if (
              typeof priceResponse.data === "object" &&
              priceResponse.data !== null
            ) {
              basePrice = priceResponse.data.price || 0;
              gstAmount = priceResponse.data.taxAmount || 0;
              surchargeDetails = priceResponse.data.surchargeDetails || [];
            }
          }

          // Calculate number of nights
          const nights = calculateNights(checkinDate, checkoutDate);

          // ✅ CRITICAL FIX: Calculate per-night price
          const perNightPrice = nights > 0 ? basePrice / nights : basePrice;

          // ✅ STEP 2: Get discount calculation (same as QueueTooltip)
          let discountData = [];
          let activeDiscount = null;
          let discountAmount = 0;

          try {
            const discountPayload = {
              client_id: clientId,
              items: [
                {
                  service_id: serviceId,
                  vendor_pet_id: vendor_pet_id,
                  start_date: checkinDate,
                  end_date: checkoutDate,
                  unit_price: perNightPrice, // ✅ Pass per-night price for discount calculation
                  item_type: "boarding",
                },
              ],
            };

            const discountResponse = await httpService.post(
              "/vendorbooking/getDiscountCalculation",
              discountPayload,
            );

            if (
              discountResponse.data &&
              discountResponse.data.items &&
              discountResponse.data.items.length > 0
            ) {
              discountData = discountResponse.data.items[0].discount || [];

              // Find active discount
              activeDiscount = discountData.find(
                (d) => Number(d.is_active) === 1,
              );

              if (activeDiscount) {
                // ✅ Discount amount is PER NIGHT, multiply by nights
                discountAmount = (activeDiscount.discount_amount || 0) * nights;
              }
            }
          } catch (discountError) {
            console.warn("⚠️ Could not fetch discount:", discountError);
            // Continue without discount
          }

          // ✅ STEP 3: Apply discount calculation
          const discountedBasePrice = Math.max(0, basePrice - discountAmount);

          // 2. Calculate GST percentage from original amounts
          const originalGstPercentage =
            basePrice > 0 ? (gstAmount / basePrice) * 100 : 0;

          // 3. Apply same GST percentage to discounted base price
          const discountedGstAmount =
            discountedBasePrice * (originalGstPercentage / 100);

          // 4. Calculate addons total
          const addonsTotal =
            appointment.addons?.reduce((sum, addon) => {
              return sum + (addon.addon_price || addon.price || 0);
            }, 0) || 0;

          // 5. Calculate final total
          const totalPrice =
            discountedBasePrice + discountedGstAmount + addonsTotal;

          // ✅ STEP 4: Batch both state updates together
          const newPriceData = {
            price: discountedBasePrice,
            taxAmount: discountedGstAmount,
            discount: discountAmount,
            subtotal: discountedBasePrice,
            total: Math.max(0, totalPrice),
          };

          // Update boarding price data AND appointment list in same render cycle
          setBoardingPriceData(newPriceData);

          setAppointmentList((prev) => {
            const updatedList = [...prev];
            const boardingIndex = updatedList.findIndex(
              (app) => app.item_type?.toLowerCase() === "boarding",
            );

            if (boardingIndex !== -1) {
              const preservedStatus =
                updatedList[boardingIndex].status || "confirmed";

              updatedList[boardingIndex] = {
                ...updatedList[boardingIndex],
                // ✅ Store per-night price for display
                unit_price: perNightPrice,
                // ✅ Store total base price
                price: basePrice,
                // ✅ Store total price after discount and tax
                total_price: Math.max(0, totalPrice),
                gst: discountedGstAmount,
                discount: discountAmount,
                discounts: discountData,
                status: preservedStatus,
                // ✅ Store the per-night unit price separately
                per_night_unit_price: perNightPrice,
              };
            }

            return updatedList;
          });

          // Update previous values ref
          previousBoardingValuesRef.current = currentValues;
        } catch (error) {
          console.error("Price calculation error:", error);
          toast.error("Failed to calculate price");
        } finally {
          setIsCalculatingPrice(false);
          priceCalcInFlightRef.current = false;
        }
      }, 500); // 500ms debounce delay
    },
    // [clientData?._id, mode, calculateTotals],
    [clientData?._id, mode],// calculateTotals],
  );

  // Helper function to calculate nights
  const calculateNights = (startDate, endDate) => {
    if (!startDate || !endDate) return 0;
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  // Fetch order discount and initialize GST when order data is loaded
  useEffect(() => {
    if (orderData && mode === "update") {
      // Initialize boarding price data with GST from order if boarding appointment exists
      if (appointmentList.length > 0) {
        const boardingIndex = appointmentList.findIndex(
          (app) => app.item_type?.toLowerCase() === "boarding",
        );

        if (boardingIndex !== -1) {
          const boardingAppointment = appointmentList[boardingIndex];
          const currentPrice = parseFloat(
            boardingAppointment.unit_price ||
              boardingAppointment.total_price ||
              0,
          );
          const currentGst = parseFloat(boardingAppointment.gst || 0);
          // Use individual item's discount instead of total order discount
          const itemDiscount = parseFloat(boardingAppointment.discount || 0);
          setOrderDiscount(itemDiscount);

          setBoardingPriceData({
            price: currentPrice,
            taxAmount: currentGst,
            discount: itemDiscount,
            subtotal: currentPrice,
            total: Math.max(0, currentPrice + currentGst - itemDiscount),
          });

          // Initialize previous values for change detection
          previousBoardingValuesRef.current = {
            checkinDate: boardingAppointment.start_date,
            checkoutDate: boardingAppointment.end_date,
            roomTypeId: boardingAppointment.room_type_id,
            roomNumber: boardingAppointment.room_number || "",
          };
        }
      }
    }
  }, [orderData, mode, appointmentList]);

  // Update boarding price data when order discount changes
  useEffect(() => {
    if (mode === "update" && boardingPriceData.price > 0) {
      const subtotal = boardingPriceData.price;
      const total = subtotal + boardingPriceData.taxAmount;

      setBoardingPriceData((prev) => ({
        ...prev,
        // discount: orderDiscount,
        subtotal: subtotal,
        total: Math.max(0, total),
      }));

      // Update the boarding appointment in the list with new price data
      setAppointmentList((prev) => {
        const updatedList = [...prev];
        const boardingIndex = updatedList.findIndex(
          (app) => app.item_type?.toLowerCase() === "boarding",
        );

        if (boardingIndex !== -1) {
          updatedList[boardingIndex] = {
            ...updatedList[boardingIndex],
            unit_price: boardingPriceData.price,
            total_price: Math.max(0, total),
            gst: boardingPriceData.taxAmount,
            // discount: orderDiscount, // Update the discount in the appointment as well
          };
        }

        return updatedList;
      });
    }
  }, [
    orderDiscount,
    mode,
    boardingPriceData.price,
    boardingPriceData.taxAmount,
  ]);

  /* -------------------------- Time slot generator ------------------------- */
  const generateTimeSlots = () => {
    const slots = [];
    let start = 8 * 60; // 8:00 AM
    const end = 20 * 60; // 8:00 PM
    while (start <= end) {
      const hours = Math.floor(start / 60);
      const minutes = start % 60;
      const formatted = new Date(0, 0, 0, hours, minutes).toLocaleTimeString(
        "en-IN",
        {
          hour: "numeric",
          minute: "2-digit",
        },
      );
      slots.push(formatted);
      start += 15;
    }
    return slots;
  };
  const timeSlots = generateTimeSlots();

  /* --------------------- Appointment inline field change ------------------ */
  const handleAppointmentFieldChange = useCallback(
    (index, field, value) => {
      setAppointmentList((prev) => {
        // Create a copy of the current list
        const updatedList = [...prev];

        // Get the current appointment
        const currentAppointment = updatedList[index];

        // Only update if the value actually changed
        if (currentAppointment[field] === value) {
          return prev;
        }

        const currentStatus = currentAppointment.status || "confirmed";

        // SPECIAL CASE: When room_number changes, we need to find the corresponding room_id
        if (field === "room_number") {
          // Find the room type from current appointment
          const roomTypeId = currentAppointment.room_type_id;
          const roomType = rooms.find((room) => room._id === roomTypeId);

          if (roomType && roomType.room_numbers) {
            // Find the bed with this room number
            const bed = roomType.room_numbers.find(
              (bed) => bed.room_number === String(value),
            );

            if (bed) {
              // Update BOTH room_number AND room_id
              updatedList[index] = {
                ...currentAppointment,
                room_number: String(value),
                room_id: bed._id, // ✅ CRITICAL: Update room_id with bed's _id
              };
            } else {
              console.warn(
                `⚠️ DEBUG - No bed found for room number ${value} in room type ${roomTypeId}`,
              );
              // Just update the room_number, room_id will be empty
              updatedList[index] = {
                ...currentAppointment,
                room_number: String(value),
                room_id: "", // Clear room_id if bed not found
              };
            }
          } else {
            console.warn(
              `⚠️ DEBUG - Room type ${roomTypeId} not found or has no beds`,
            );
            // Just update the room_number
            updatedList[index] = {
              ...currentAppointment,
              [field]: value,
              status: currentStatus,
            };
          }
        } else {
          // Normal field update
          updatedList[index] = {
            ...currentAppointment,
            [field]: value,
            status: currentStatus,
          };
        }

        // Trigger price calculation for boarding appointments only when relevant fields change
        if (
          updatedList[index].item_type?.toLowerCase() === "boarding" &&
          mode === "update"
        ) {
          if (
            field === "start_date" ||
            field === "end_date" ||
            field === "room_type_id" ||
            field === "room_number" ||
            field === "room_id" // Also trigger for room_id changes
          ) {
            // Show debounced toast message for field changes
            let fieldDisplayName = "";
            switch (field) {
              case "start_date":
                fieldDisplayName = "check-in date";
                break;
              case "end_date":
                fieldDisplayName = "check-out date";
                break;
              case "room_type_id":
                fieldDisplayName = "room type";
                break;
              case "room_number":
                fieldDisplayName = "room number";
                break;
              case "room_id":
                fieldDisplayName = "room ID";
                break;
              default:
                fieldDisplayName = field;
            }

            if (toastTimerRef.current) {
              clearTimeout(toastTimerRef.current);
            }

            toastTimerRef.current = setTimeout(() => {
              toast.info(
                `${
                  fieldDisplayName.charAt(0).toUpperCase() +
                  fieldDisplayName.slice(1)
                } changed. Recalculating price...`,
                {
                  position: "top-center",
                  autoClose: 2000,
                },
              );
            }, 100);

            // Trigger price calculation
            setTimeout(() => {
              scheduleBoardingPriceCalculation(updatedList[index], index);
            }, 300);
          }
        }

        return updatedList;
      });
    },
    [mode, clientData?._id, rooms],
  ); // ✅ Added 'rooms' to dependencies

  /* --------------------- Fetch rooms when room type changes ------------------ */
  const handleRoomTypeChange = useCallback(
    (index, roomTypeId) => {
      if (!roomTypeId) {
        console.warn("⚠️ Room type ID is empty");
        return;
      }

      // ✅ Update the appointment with new room type
      handleAppointmentFieldChange(index, "room_type_id", roomTypeId);

      // ✅ Clear room_id and room_number when room type changes
      // This forces user to select a new room number
      handleAppointmentFieldChange(index, "room_id", "");
      handleAppointmentFieldChange(index, "room_number", "");
    },
    [handleAppointmentFieldChange],
  ); // ✅ Added dependency
  /* -------------------------- Update schedule API ------------------------- */
  // Replace your handleUpdateSchedule function with this fixed version

  const handleUpdateSchedule = async () => {
    // 1️⃣ Validation: Check if orderId exists
    if (!orderId) {
      toast.error("Order ID missing");
      return;
    }

    // Prevent multiple submissions
    if (pendingUpdateRef.current) {
      console.warn("⚠️ Update already in progress, ignoring duplicate request");
      toast.warning("Update is already in progress, please wait...");
      return;
    }

    const validationResult = validateAllAppointments(appointmentList);

    if (!validationResult.isValid) {
      // Show first conflict to user
      const firstConflict = validationResult.conflicts[0];
      toast.error(firstConflict.conflictMessage, {
        position: "top-center",
        autoClose: 5000,
      });

      // Highlight conflicting appointments
      setConflictingAppointments(
        validationResult.conflicts.map((c) => c.index),
      );

      // Clear highlight after 5 seconds
      setTimeout(() => {
        setConflictingAppointments([]);
      }, 5000);

      pendingUpdateRef.current = false;
      return;
    }

    // Clear any previous conflict highlights
    setConflictingAppointments([]);

    // 2️⃣ Validation: Check appointment status and dates
    for (let i = 0; i < appointmentList.length; i++) {
      const appointment = appointmentList[i];
      const status = appointment.status?.toLowerCase();

      if (status === "started" || status === "completed") {
        toast.error(
          `Cannot reschedule appointment with '${appointment.status}' status.`,
        );
        return;
      }

      if (appointment.item_type?.toLowerCase() === "boarding") {
        if (appointment.start_date && appointment.end_date) {
          const checkinDate = new Date(appointment.start_date);
          const checkoutDate = new Date(appointment.end_date);

          // Validate room is selected
          if (!appointment.room_id || !appointment.room_type_id) {
            toast.error(
              `Booking ${i + 1}: Please select a room before updating.`,
            );
            return;
          }

          if (checkoutDate <= checkinDate) {
            toast.warning(
              `Booking ${i + 1}: Check-out date should ideally be after check-in date.`,
            );
          }
        }
      } else {
        if (appointment.start_date && appointment.start_time) {
          try {
            const appointmentDateTime = new Date(
              `${appointment.start_date} ${appointment.start_time}`,
            );
            const now = new Date();

            if (appointmentDateTime < now) {
              const apptDay = appointment.start_date;
              if (!allowPastBooking || isBeforeMinBookingDate(apptDay, minDate)) {
                toast.error(
                  allowPastBooking
                    ? `Appointment ${i + 1}: ${pastBookingBlockedMessage(true, maxPastDays, "Appointments")}`
                    : `Appointment ${i + 1} cannot be scheduled in the past. Please select a future date and time.`,
                );
                return;
              }
            }
          } catch (err) {
            console.warn("Could not parse appointment date/time:", err);
          }
        }
      }
    }

    // 3️⃣ Mark update as in progress
    pendingUpdateRef.current = true;

    try {
      // 4️⃣ Build the API payload
      const payload = {
        order_type: orderData?.order_type,
        vendor_client_id: clientData?._id,
        order_id: orderId,
        order_items: appointmentList.map((item, itemIndex) => {
          const currentStatus = item.status || "confirmed";
          // Base item data common to all types
          const baseItem = {
            item_type: item.item_type || "grooming",
            pet_id: item.vendor_pet_id || item.pet_id,
            vendor_pet_id: item.vendor_pet_id || item.pet_id,
            pet_name: item.pet_name || "",
            pet_type: item.pet_type || "",
            pet_size: item.pet_size || "",
            pet_breed: item.pet_breed || "",
            service_id: item.service_id,
            service_name: item.service_name || "",
            service_category_type_id: item.service_category_type_id,
            service_type_name: item.service_type_name || "",
            quantity: item.quantity || 1,
            unit_price: parseFloat(item.unit_price) || 0,
            discount: parseFloat(item.discount) || 0,
            gst: parseFloat(item.gst) || 0,
            total_price: parseFloat(item.total_price) || 0,
            addons: item.addons || [],
            price_surcharge: item.price_surcharge || [],
            status: currentStatus,

            // Add ref_id for existing items
            ...(item.ref_id
              ? { ref_id: item.ref_id }
              : item._id
                ? { ref_id: item._id }
                : item.id
                  ? { ref_id: item.id }
                  : {}),
          };

          // 5️⃣ Handle BOARDING items
          if (item.item_type?.toLowerCase() === "boarding") {
            const boardingPayload = {
              ...baseItem,
              start_date: item.start_date,
              end_date: item.end_date,
              room_type_id: item.room_type_id, // ✅ Should be new value
              room_id: item.room_id, // ✅ Should be new value
              room_number: String(item.room_number || ""),
              room_name: item.room_name || "",

              // Use calculated boarding price if available
              unit_price:
                boardingPriceData.price > 0
                  ? boardingPriceData.price
                  : parseFloat(item.unit_price) || 0,
              total_price:
                boardingPriceData.total > 0
                  ? boardingPriceData.total
                  : parseFloat(item.total_price) || 0,
              gst:
                boardingPriceData.taxAmount > 0
                  ? boardingPriceData.taxAmount
                  : parseFloat(item.gst) || 0,
              price_surcharge: item.price_surcharge || [],
            };

            return boardingPayload;
          }
          // 6️⃣ Handle APPOINTMENT items
          else {
            const appointmentPayload = {
              ...baseItem,
              technician_id: item.technician_id || "",
              employee_name: item.employee_name || "",
              start_date: item.start_date,
              start_time: item.start_time,
              duration: item.duration || "1 hr",
            };

            return appointmentPayload;
          }
        }),
      };

      // 7️⃣ Make the API call
      const response = await httpService.post(
        "/vendororder/addVendorOrderOrUpdate",
        payload,
      );

      // 8️⃣ Show success message
      toast.success("Schedule updated successfully!", {
        position: "top-center",
        autoClose: 3000,
      });

      // 9️⃣ Refresh parent data
      if (refreshClients && typeof refreshClients === "function") {
        setTimeout(async () => {
          try {
            await refreshClients();
          } catch (err) {
            console.error("Error refreshing clients:", err);
          }
        }, 100);
      }

      // 🔟 Refresh calendar/appointment data globally
      refreshCalendarData();

      // 1️⃣1️⃣ Close the drawer after a short delay
      setTimeout(() => {
        handleClose();
      }, 500);
    } catch (err) {
      console.error("❌ Failed updating schedule:", err);
      console.error("Error details:", err.response?.data || err.message);

      if (err.response?.data?.message) {
        toast.error(`Error: ${err.response.data.message}`);
      } else {
        toast.error("Failed to update schedule. Please try again.");
      }
    } finally {
      // 1️⃣2️⃣ Mark update as complete
      pendingUpdateRef.current = false;
    }
  };

  // Handler for payment completion
  const handlePaymentComplete = async () => {
    if (isPaymentLoading) return; // Prevent multiple calls

    setIsPaymentLoading(true);

    try {
      const totals = totalSummary;
      const totalAmount = parseFloat(totals.total || 0);
      const paidAmount = parseFloat(orderData.total_paid_amount || 0);
      const remainingAmount = Math.max(0, totalAmount - paidAmount);
      const paymentAmount = parseFloat(paymentDetails.amount || 0);

      // Validation
      if (paymentAmount <= 0) {
        toast.error("Payment amount must be greater than zero", {
          position: "top-center",
        });
        return;
      }

      if (!paymentDetails.method) {
        toast.error("Please select a payment method", {
          position: "top-center",
        });
        return;
      }

      // if (paymentAmount > remainingAmount) {
      //   toast.error("Payment amount cannot exceed the remaining amount", {
      //     position: "top-center",
      //   });
      //   return;
      // }

      // Validate required fields
      if (!orderData?.order_number || !clientData?._id) {
        toast.error(
          "Missing order or client information. Please refresh and try again.",
          {
            position: "top-center",
          },
        );
        return;
      }

      // Get vendor_id from token data
      const { data } = tokenDecode();
      const calculatedTotals = totalSummary;

      const paymentPayload = {
        vendor_id: data.user.vendor_id,
        client_id: clientData._id,
        order_id: orderId,
        order_number: orderData.order_number,
        order_type: orderData.order_type,
        subtotal_amount: parseFloat(calculatedTotals.subtotal),
        gst: parseFloat(calculatedTotals.gst),
        discount: parseFloat(calculatedTotals.discount),
        paid_amount: paymentAmount,
        payment_mode: paymentDetails.method,
        reference_number: paymentDetails.reference,
      };

      const response = await httpService.post(
        "/orderpayment/addOrderPayment",
        paymentPayload,
      );

      if (response.status) {
        toast.success("Payment added successfully!", {
          position: "top-center",
        });

        // Calculate new payment status
        const currentPaidAmount = parseFloat(orderData.total_paid_amount || 0);
        const newTotalPaidAmount = currentPaidAmount + paymentAmount;
        const newPaymentStatus =
          newTotalPaidAmount >= totalAmount ? "paid" : "partial";

        // Update order in backend
        try {
          const orderUpdatePayload = {
            order_id: orderId,
            total_paid_amount: newTotalPaidAmount,
            payment_status: newPaymentStatus,
          };

          await httpService.post(
            "/vendororder/addVendorOrderOrUpdate",
            orderUpdatePayload,
          );
        } catch (updateErr) {
          console.error("Failed to update order in backend:", updateErr);
          toast.warning(
            "Payment added but order update failed. Please refresh to see updated amount.",
            {
              position: "top-center",
            },
          );
        }

        // Update local order data
        const updatedOrderData = {
          ...orderData,
          total_paid_amount: newTotalPaidAmount,
          payment_status: newPaymentStatus,
        };
        setOrderData(updatedOrderData);

        // Reset payment form
        setPaymentDetails({
          paymentType: "",
          amount: "",
          method: "cash",
          reference: "",
          notes: "",
        });
        setShowPaymentSection(false);

        // Refresh parent component data
        if (refreshClients) {
          setTimeout(async () => {
            await refreshClients();
          }, 100);
        }

        // Refresh other data sources
        if (window.refreshOrderData) {
          await window.refreshOrderData();
        }
        refreshCalendarData();

        // Refetch order data for accuracy
        try {
          const orderRes = await httpService.get(
            `/vendororder/getvendororder/${orderId}`,
          );
          const refreshedOrder = orderRes.data;
          setOrderData(refreshedOrder);
        } catch (err) {
          console.error("Failed to refresh order data after payment:", err);
        } finally {
          handleClose();
        }
      }
    } catch (error) {
      console.error("Error adding payment:", error);
      toast.error("Failed to add payment. Please try again.", {
        position: "top-center",
      });
    } finally {
      setIsPaymentLoading(false);
    }
  };

  // Handler for back button in payment section
  const handleBackFromPayment = () => {
    setShowPaymentSection(false);
    setPaymentDetails({
      paymentType: "",
      amount: "",
      method: "",
      reference: "",
      notes: "",
    });

    // Refresh calendar & queue once payment drawer is closed
    refreshCalendarData();
  };

  // Handler for Add Pets & Services
  const handleAddPetsAndServices = () => {
    setDrawerEditMode(false);
    setItemData({
      vendor_client_id: clientData?._id,
      order_id: orderId,
      fromBookingDetails: true,
    });
    //setShowPetServiceDrawer(false);
    setShowPetServiceDrawer(true);
  };

  // Handler for editing appointment from list
  const handleEditAppointmentFromList = async (appointment, index) => {
    try {
      if (appointment.ref_id) {
        // First, get the original item from orderData to get the exact item_type
        const originalOrderItem = orderData?.order_items?.find(
          (item) =>
            item._id === appointment._id || item.ref_id === appointment.ref_id,
        );

        if (!originalOrderItem) {
          toast.error("Could not find original order item for editing");
          return;
        }

        const itemType = originalOrderItem.item_type?.toLowerCase();
        let response;

        // Call appropriate API based on item type
        if (itemType === "boarding" || itemType === "day_care") {
          if (refId && sourceType === "queue") {
            // If opened from queue, use queue API
            response = await httpService.get(
              `/vendorbooking/getVendorBooking/${appointment.ref_id}`,
            );
          } else {
            // Regular booking API
            response = await httpService.get(
              `/vendorbooking/getVendorBooking/${appointment.ref_id}`,
            );
          }
        } else if (itemType === "product") {
          // For products, we don't edit through service drawers
          toast.info(
            "Product editing is not supported in this view. Please use the main booking details to edit products.",
            {
              position: "top-center",
            },
          );
          return;
        } else {
          // For all other service types (grooming, dog_walking, vet_clinic, etc.)
          if (refId && sourceType === "queue") {
            // If opened from queue, use queue API
            response = await httpService.get(
              `/vendorappointment/getVendorAppointment/${appointment.ref_id}`,
            );
          } else {
            // Regular appointment API
            response = await httpService.get(
              `/vendorappointment/getVendorAppointment/${appointment.ref_id}`,
            );
          }
        }

        if (response?.data) {
          const editData = {
            ...response.data,
            // Ensure pet and service ids are present for downstream drawers
            pet_id: appointment.pet_id || response.data.vendor_pet_id,
            vendor_pet_id: appointment.pet_id || response.data.vendor_pet_id,
            service_id: appointment.service_id || response.data.service_id,
            vendor_client_id: clientData?._id,
            service_category_type_id:
              response.data.service_category_type_id ||
              appointment.service_category_type_id ||
              originalOrderItem.service_category_type_id,
            service_type_name:
              response.data.service_type_name ||
              appointment.service_type_name ||
              appointment.service_name ||
              originalOrderItem.service_type_name,
            service_name:
              response.data.service_name ||
              appointment.service_name ||
              appointment.service_type_name ||
              originalOrderItem.service_name, // Ensure service_name is set
            room_type_id:
              originalOrderItem.room_type_id ||
              response.data.room_type_id ||
              appointment.room_type_id, // Get room_type_id from original order item
            employee_id: appointment.technician_id,
            employee_name: appointment.employee_name,
            start_date: appointment.start_date || originalOrderItem.start_date,
            end_date: appointment.end_date || originalOrderItem.end_date,
            start_time: appointment.start_time || originalOrderItem.start_time,
            order_id: orderId,
            item_type: originalOrderItem.item_type, // Use original item_type from order
            notes:
              response.data.notes ||
              appointment.notes ||
              originalOrderItem.notes ||
              "", // Add notes field from API response first
            frequency:
              response.data.frequency ||
              appointment.frequency ||
              originalOrderItem.frequency ||
              "", // Add frequency field from vendorbooking API response
            numberOfTimes:
              appointment.numberOfTimes ||
              originalOrderItem.number_of_times ||
              "", // Add numberOfTimes field from appointment
            ref_id: appointment.ref_id || "", // Add ref_id field from appointment
            // Additional fields from vendorbooking API response
            duration: response.data.duration || appointment.duration || "",
            price:
              response.data.price ||
              appointment.price ||
              appointment.unit_price ||
              0,
            discount: response.data.discount || appointment.discount || 0,
            gst: response.data.gst || appointment.gst || 0,
            total_price:
              response.data.total_price || appointment.total_price || 0,
            quantity: response.data.quantity || appointment.quantity || 1,
            addons: response.data.addons || appointment.addons || [],
            service_code: response.data.service_code || "",
            client_name: response.data.client_name || "",
            pet_name: response.data.pet_name || "",
            type:
              response.data.type || originalOrderItem.item_type || "day_care",
            _editIndex: index,
            _originalAppointment: { ...appointment },
            _originalOrderItem: originalOrderItem, // Pass original order item for reference
          };

          // Set service category type for dog walking
          if (originalOrderItem.item_type === "dog_walking") {
            editData.service_category_type_id = 1; // Type 1 for dog walking
            editData.service_type_name = "Dog walking";
          }

          setItemData(editData);
          setDrawerEditMode(true);
          setShowPetServiceDrawer(true);
        }
      } else {
        // Fallback to original appointment data
        const editData = {
          ...appointment,
          // Ensure pet and service ids are present for downstream drawers
          pet_id: appointment.pet_id,
          vendor_pet_id: appointment.pet_id,
          service_id: appointment.service_id,
          vendor_client_id: clientData?._id,
          service_category_type_id: appointment.service_category_type_id,
          service_type_name:
            appointment.service_type_name || appointment.service_name,
          service_name:
            appointment.service_name || appointment.service_type_name, // Ensure service_name is set
          room_type_id: appointment.room_type_id, // Get room_type_id from appointment data
          employee_id: appointment.technician_id,
          employee_name: appointment.employee_name,
          start_date: appointment.start_date,
          end_date: appointment.end_date,
          start_time: appointment.start_time,
          order_id: orderId,
          item_type: appointment.item_type, // Ensure item_type is passed
          notes: appointment.notes || "", // Add notes field from appointment
          frequency: appointment.frequency || "", // Add frequency field from appointment
          numberOfTimes: appointment.numberOfTimes || "", // Add numberOfTimes field from appointment
          ref_id: appointment.ref_id || "", // Add ref_id field from appointment
          _editIndex: index,
          _originalAppointment: { ...appointment },
        };

        // Set service category type for dog walking in fallback case
        if (appointment.item_type === "dog_walking") {
          editData.service_category_type_id = 1; // Type 1 for dog walking
          editData.service_type_name = "Dog walking";
        }

        setItemData(editData);
        setDrawerEditMode(true);
        setShowPetServiceDrawer(true);
      }
    } catch (error) {
      console.error("Error fetching appointment/booking details:", error);
      toast.error("Failed to load details for editing");
    }
  };

  // Handler for deleting product from list
  const handleDeleteProductFromList = async (index) => {
    const product = productList[index];

    const result = await Swal.fire({
      title: "Delete Product?",
      text: `Do you want to delete "${product.name}" from this order?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        // Find the corresponding order item with the product's _id
        const orderItem = orderData?.order_items?.find(
          (item) =>
            item.item_type === "product" &&
            item.service_name === product.name &&
            item.unit_price === product.unit_price &&
            item.quantity === product.quantity,
        );

        // Call the delete API if we found the order item and have orderId
        if (orderItem?._id && orderId) {
          await httpService.delete(
            `vendororder/deletevendororderitem/${orderId}/${orderItem._id}`,
          );
        }

        // Remove from local state
        setProductList((prev) => prev.filter((_, i) => i !== index));

        toast.success("Product removed from order!", {
          position: "top-center",
        });
        fetchOrderAndClient();

        // Force refresh of parent clients data
        // if (refreshClients) {
        //   setTimeout(async () => {
        //     await refreshClients();
        //   }, 100);
        // }

        // Refresh calendar data
        refreshCalendarData();
      } catch (error) {
        console.error("Error deleting product:", error);
        toast.error("Failed to delete product", {
          position: "top-center",
        });
      }
    }
  };

  // Handler for deleting appointment/booking from list
  const handleDeleteAppointmentFromList = async (appointment, index) => {
    const itemType =
      appointment.item_type?.toLowerCase() === "boarding"
        ? "booking"
        : "appointment";

    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete this ${itemType} item?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        // Call the delete API if the item has an ID
        if (appointment._id && orderId) {
          await httpService.delete(
            `vendororder/deletevendororderitem/${orderId}/${appointment._id}`,
          );
        }

        // Remove from local state
        setAppointmentList((prev) => prev.filter((_, i) => i !== index));

        Swal.fire({
          title: "Deleted!",
          text: `${
            itemType.charAt(0).toUpperCase() + itemType.slice(1)
          } has been deleted.`,
          icon: "success",
          confirmButtonText: "OK",
        });

        toast.success(
          `${
            itemType.charAt(0).toUpperCase() + itemType.slice(1)
          } deleted successfully!`,
          {
            position: "top-center",
          },
        );

        // Force refresh of parent clients data
        if (refreshClients) {
          setTimeout(async () => {
            await refreshClients();
          }, 100);
        }

        // Refresh calendar data
        refreshCalendarData();
      } catch (error) {
        console.error(`Error deleting ${itemType}:`, error);
        Swal.fire({
          title: "Error",
          text: `Failed to delete ${itemType}.`,
          icon: "error",
          confirmButtonText: "OK",
        });
        toast.error(`Failed to delete ${itemType}`, {
          position: "top-center",
        });
      }
    }
  };

  // Handle status update
  const handleStatusUpdate = async (appointment, newStatus, index) => {
    // Validation for grooming, vet clinic, and dog walking
    const appointmentType = appointment.item_type?.toLowerCase();
    if (
      appointmentType === "grooming" ||
      appointmentType === "vet_clinic" ||
      appointmentType === "dog_walking"
    ) {
      if (
        !appointment.start_date ||
        !appointment.start_time ||
        !appointment.technician_id
      ) {
        toast.error(
          "Please complete the appointment details (date, time, and staff) first before changing status",
          {
            position: "top-center",
          },
        );
        return;
      }
    }

    // Validation for boarding
    if (appointmentType === "boarding") {
      if (
        !appointment.start_date ||
        !appointment.end_date ||
        !appointment.room_id ||
        !appointment.room_type_id
      ) {
        toast.error(
          "Please complete the booking details (check-in date, check-out date, and room assignment) first before changing status",
          {
            position: "top-center",
          },
        );
        return;
      }
    }

    // Validation for day care
    if (appointmentType === "day_care" || appointmentType === "daycare") {
      if (!appointment.start_date) {
        toast.error(
          "Please complete the booking details (check-in date) first before changing status",
          {
            position: "top-center",
          },
        );
        return;
      }
    }

    const result = await Swal.fire({
      title: "Update Status?",
      text: `Do you want to change the status to "${newStatus}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    });

    if (!result.isConfirmed) return;

    try {
      if (appointment.ref_id) {
        const apiStatus = StatusUtils.toApi(newStatus);

        // Use different API endpoints based on item type
        let endpoint;
        if (appointment.item_type?.toLowerCase() === "boarding") {
          endpoint = `/vendorbooking/updateVendorBookingStatus/${appointment.ref_id}`;
        } else {
          endpoint = `/vendorappointment/updateVendorAppointmentStatus/${appointment.ref_id}`;
        }

        // Update status via API
        await httpService.put(endpoint, {
          status: apiStatus,
        });

        // Update local state with the new display status (this is the key fix)
        setAppointmentList((prev) =>
          prev.map(
            (app, i) => (i === index ? { ...app, status: newStatus } : app), // Store display status directly
          ),
        );

        Swal.fire("Updated!", `Status changed to ${newStatus}.`, "success");

        // Force refresh of parent clients data
        if (refreshClients) {
          setTimeout(async () => {
            await refreshClients();
          }, 100);
        }

        // Refresh calendar data
        if (typeof window !== "undefined") {
          if (
            appointment.item_type?.toLowerCase() === "boarding" &&
            typeof window.refreshBoardingData === "function"
          ) {
            window.refreshBoardingData();
          } else if (typeof window.refreshAppointmentData === "function") {
            window.refreshAppointmentData();
          }
        }
      }
    } catch (error) {
      console.error("Error updating status:", error);
      Swal.fire("Error", "Failed to update status.", "error");
    }
  };

  const handleSavedAppointment = async (data) => {
    // Check if this is appointment data from NewServiceDrawer (not API response)
    if (data.pet_name && data.service_name && !data._id) {
      // Check if this is an edit operation (has _editIndex)
      if (data._editIndex !== undefined) {
        const editIndex = data._editIndex;
        setAppointmentList((prev) => {
          const updatedList = [...prev];
          const updatedData = { ...data };
          delete updatedData._editIndex;
          delete updatedData._originalAppointment;
          updatedList[editIndex] = updatedData;
          return updatedList;
        });

        const serviceType = data.item_type || data.service_type_name || "";
        if (
          serviceType.toLowerCase() === "day_care" ||
          serviceType.toLowerCase() === "daycare"
        ) {
          toast.success("Daycare updated successfully!", {
            position: "top-center",
          });
        } else {
          toast.success("Appointment updated successfully!", {
            position: "top-center",
          });
        }
      } else {
        setAppointmentList((prev) => [...prev, data]);
        const serviceType = data.item_type || data.service_type_name || "";
        if (
          serviceType.toLowerCase() === "day_care" ||
          serviceType.toLowerCase() === "daycare"
        ) {
          toast.success("Daycare added successfully!", {
            position: "top-center",
          });
        } else {
          toast.success("Appointment added successfully!", {
            position: "top-center",
          });
        }
      }
      setShowPetServiceDrawer(false);
      return;
    }

    // Original API response handling for actual saving
    if (data._id) {
      toast.success("Booking updated successfully!", {
        position: "top-center",
      });

      // Refresh the order data
      if (orderId) {
        try {
          const orderRes = await httpService.get(
            `/vendororder/getvendororder/${orderId}`,
          );
          const order = orderRes.data;
          setOrderData(order);

          // Transform order items to appointment list format
          if (order.order_items) {
            const convertFrequencyToUI = (freq) => {
              switch (freq) {
                case "One Time":
                  return "one_time";
                case "Weekly":
                  return "weekly";
                case "Monthly":
                  return "monthly";
                case "Quarterly":
                  return "quaterly";
                default:
                  return freq.toLowerCase();
              }
            };

            const convertNumberOfTimesToUI = (times) => {
              switch (times) {
                case "Once":
                  return "once";
                case "Twice":
                  return "twice";
                default:
                  return times.toLowerCase();
              }
            };

            const transformedItems = order.order_items.map((item, index) => ({
              id: `${orderId}-${index}`,
              _id: item._id,
              pet_name: item.pet_name || "Unknown Pet",
              pet_size: item.pet_size || "",
              pet_breed: item.pet_breed || "",
              service_name: item.service_name || item.name || "Service",
              service_type_name:
                item.service_type_name || item.service_category_name || "",
              service_id: item.service_id,
              pet_id: item.vendor_pet_id,
              vendor_pet_id: item.vendor_pet_id,
              technician_id: item.technician_id,
              employee_name: item.employee_name || "",
              start_date: item.start_date,
              end_date: item.end_date,
              start_time: item.start_time,
              duration: item.duration || "1 hr",
              unit_price: item.unit_price || item.price || 0,
              total_price:
                item.total_price || item.unit_price || item.price || 0,
              discounts: item.discounts,
              gst: item.gst || 0,
              status: item.status || "booked",
              item_type: item.item_type || "grooming",
              addons: item.addons || [],
              products: item.products || [],
              ref_id: item.ref_id,
              service_category_type_id: item.service_category_type_id,
              service_barcode: item.service_barcode,
              notes: item.notes || "",
              frequency: convertFrequencyToUI(item.frequency || ""),
              numberOfTimes: convertNumberOfTimesToUI(
                item.number_of_times || "",
              ),
              base_total: item?.base_total,
            }));
            setAppointmentList(transformedItems);
          }

          // Force refresh of parent clients data
          if (refreshClients) {
            setTimeout(async () => {
              await refreshClients();
            }, 100);
          }
        } catch (err) {
          console.error("Failed refreshing order", err);
        }
      }

      setShowPetServiceDrawer(false);
    }
  };

  const handleDeleteEnquiry = async (enquiry) => {
    const result = await Swal.fire({
      title: "Delete Enquiry?",
      text: "Are you sure you want to delete this enquiry?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        // Call delete API if available
        // await httpService.delete(`/vendororder/deleteEnquiry/${enquiry._id}`);

        // Remove from local state
        setEnquiryData((prev) => prev.filter((e) => e._id !== enquiry._id));

        toast.success("Enquiry deleted successfully!", {
          position: "top-center",
        });
      } catch (error) {
        console.error("Error deleting enquiry:", error);
        toast.error("Failed to delete enquiry", {
          position: "top-center",
        });
      }
    }
  };

  const handleSaveEnquiryBooking = async (enquiry) => {
    try {
      const enquiryItems = enquiry.items.map((item) => {
        if (item.type === "product") {
          return {
            item_type: "product",
            vendor_pet_id: item.vendor_pet_id || "",
            service_id: item.vendor_product_id || item.service_id,
            description: item.description || "",
            sku_number: (item.sku_number || "").toString().trim(),
            quantity: parseFloat(item.quantity || 0),
            unit_price: parseFloat(item.price || item.unit_price || 0),
            gst: parseFloat(item.gst || 0),
            total_price: parseFloat(item.total_price || 0),
            addons: item.addons || [],
          };
        } else {
          return {
            item_type: item.item_type || "grooming",
            service_category_type_id: item.service_category_type_id,
            vendor_pet_id: item.vendor_pet_id,
            service_id: item.service_id,
            technician_id: item.technician_id,
            start_date: item.start_date || item.appointment_date,
            start_time: item.time_slot,
            duration: item.duration,
            quantity: 1,
            unit_price: parseFloat(item.price || 0),
            gst: parseFloat(item.gst || 0),
            total_price: parseFloat(item.total_price || 0),
            addons: item.addons || [],
          };
        }
      });

      const payload = {
        booking_type: 2, // "booking"
        vendor_client_id: clientData?._id,
        order_items: enquiryItems,
        discount_type: discount.type,
        discount_value: discount.value,
        discount_amount: discount.amount,
        notes,
      };

      await httpService.post("/vendorappointment/addBooking", payload);

      // Delete enquiry since it has been converted to booking
      try {
        await httpService.delete(
          `/vendororderenquiry/deleteOrderEnquiry/${enquiry._id}`,
        );
      } catch (deleteErr) {
        console.error(
          "Failed to delete enquiry after booking conversion",
          deleteErr,
        );
      }

      toast.success("Enquiry converted to booking successfully!", {
        position: "top-center",
      });

      // Remove from enquiries and refresh
      setEnquiryData((prev) => prev.filter((e) => e._id !== enquiry._id));

      // Force refresh of parent clients data
      if (refreshClients) {
        setTimeout(async () => {
          await refreshClients();
        }, 100);
      }

      refreshCalendarData();
    } catch (error) {
      console.error("Error converting enquiry to booking:", error);
      toast.error("Failed to convert enquiry to booking", {
        position: "top-center",
      });
    }
  };

  const handleSaveEnquiryWithPayment = async (enquiry) => {
    setSelectedEnquiryForPayment(enquiry);
    // Initialize payment form with correct field names
    setPaymentDetails({
      paymentType: "full",
      method: "",
      amount: enquiry.total_amount || 0,
      reference: "",
      notes: "",
    });
    setShowEnquiryPaymentSection(true);
  };

  const handleEnquiryPaymentComplete = async (paymentData) => {
    if (isPaymentLoading) return; // Prevent multiple calls

    try {
      setIsPaymentLoading(true);
      const enquiry = selectedEnquiryForPayment;
      const totals = calculateEnquiryTotals();
      const totalAmount = parseFloat(totals.total);
      const paymentAmount = parseFloat(paymentData.amount || totalAmount);

      // Validation
      if (!paymentData.method) {
        toast.error("Please select a payment method", {
          position: "top-center",
        });
        return;
      }

      if (paymentData.paymentType === "partial") {
        if (!paymentData.amount || paymentAmount <= 0) {
          toast.error("Please enter a valid partial payment amount", {
            position: "top-center",
          });
          return;
        }
        if (paymentAmount > totalAmount) {
          toast.error("Partial payment amount cannot exceed total amount", {
            position: "top-center",
          });
          return;
        }
      }

      if (paymentData.method !== "cash" && !paymentData.reference) {
        toast.error("Please enter a reference number", {
          position: "top-center",
        });
        return;
      }

      const enquiryItems = enquiry.items.map((item) => {
        if (item.type === "product") {
          return {
            item_type: "product",
            vendor_pet_id: item.vendor_pet_id || "",
            service_id: item.vendor_product_id || item.service_id,
            description: item.description || "",
            sku_number: (item.sku_number || "").toString().trim(),
            quantity: parseFloat(item.quantity || 0),
            unit_price: parseFloat(item.price || item.unit_price || 0),
            discount: parseFloat(item.discount || 0),
            gst: parseFloat(item.gst || 0),
            total_price: parseFloat(
              item.total_price ||
                parseFloat(item.price || item.unit_price || 0) *
                  parseFloat(item.quantity || 0) -
                  parseFloat(item.discount || 0),
            ),
            notes: item.notes || "",
          };
        } else {
          return {
            item_type: item.item_type || "grooming",
            service_category_type_id: item.service_category_type_id,
            vendor_pet_id: item.vendor_pet_id,
            service_id: item.service_id,
            technician_id: item.technician_id,
            start_date: item.start_date || item.appointment_date,
            start_time: item.time_slot,
            duration: item.duration,
            quantity: 1,
            unit_price: parseFloat(item.price || 0),
            discount: parseFloat(item.discount || 0),
            gst: parseFloat(item.gst || 0),
            total_price: parseFloat(item.total_price || 0),
            addons: item.addons || [],
          };
        }
      });

      const payload = {
        booking_type: 3, // "booking & payment"
        vendor_client_id: clientData?._id,
        order_items: enquiryItems,
        paid_amount: paymentAmount,
        payment_mode: paymentData.method,
        reference_number:
          paymentData.method === "cash" ? "" : paymentData.reference || "",
        payment_notes: paymentData.notes || "",
        discount_type: discount.type,
        discount_value: discount.value,
        discount_amount: discount.amount,
        notes,
      };

      await httpService.post("/vendorappointment/addBooking", payload);

      // Delete enquiry since it has been converted to booking & payment
      try {
        await httpService.delete(
          `/vendororderenquiry/deleteOrderEnquiry/${enquiry._id}`,
        );
      } catch (deleteErr) {
        console.error(
          "Failed to delete enquiry after booking+payment conversion",
          deleteErr,
        );
      }

      toast.success("Enquiry converted to booking with payment successfully!", {
        position: "top-center",
      });

      // Reset payment form
      setPaymentDetails({
        paymentType: "full",
        method: "",
        amount: "",
        reference: "",
        notes: "",
      });

      // Remove from enquiries and refresh
      setEnquiryData((prev) => prev.filter((e) => e._id !== enquiry._id));
      setShowEnquiryPaymentSection(false);
      setSelectedEnquiryForPayment(null);

      // Force refresh of parent clients data
      if (refreshClients) {
        setTimeout(async () => {
          await refreshClients();
        }, 100);
      }

      refreshCalendarData();

      // Refetch order data to get accurate backend values
      try {
        const orderRes = await httpService.get(
          `/vendororder/getvendororder/${orderId}`,
        );
        const updatedOrder = orderRes.data;
        setOrderData(updatedOrder);
      } catch (err) {
        console.error(
          "Failed to refresh order data after enquiry payment:",
          err,
        );
      } finally {
        handleClose();
      }
    } catch (error) {
      console.error("Error converting enquiry to booking with payment:", error);
      toast.error("Failed to convert enquiry to booking with payment", {
        position: "top-center",
      });
    } finally {
      setIsPaymentLoading(false);
    }
  };

  const handleBackFromEnquiryPayment = () => {
    setShowEnquiryPaymentSection(false);
    setSelectedEnquiryForPayment(null);
  };

  // Calculate totals for enquiry payment
  const calculateEnquiryTotals = () => {
    if (!selectedEnquiryForPayment)
      return { subtotal: 0, gst: 0, discount: 0, total: 0 };

    const enquiry = selectedEnquiryForPayment;
    const totalAmount = parseFloat(enquiry.total_amount || 0);
    const gst = parseFloat(enquiry.total_gst || 0);
    const discount = parseFloat(enquiry.total_discount || 0);
    const subtotal = totalAmount - gst; // Subtotal excluding GST

    const total = subtotal - discount + gst;

    return {
      subtotal: subtotal.toFixed(2),
      gst: gst.toFixed(2),
      discount: discount.toFixed(2),
      total: Math.max(0, total).toFixed(2),
    };
  };

  // Custom close handler that refreshes data before closing
  const handleClose = async () => {
    try {
      // Refresh clients data if callback is available
      if (refreshClients) {
        await refreshClients();
      }

      // Also refresh calendar data if available
      refreshCalendarData();

      // Reset all state
      setOrderData(null);
      setClientData(null);
      setAppointmentList([]);
      setProductList([]);
      setShowPaymentSection(false);
      setPaymentDetails({
        paymentType: "",
        amount: "",
        method: "",
        reference: "",
        notes: "",
      });
      setAdjustmentAmount(0);
      setAdjustmentReason("");
      setSavingAdjustment(false);
      onClose();
    } catch (error) {
      console.error("Error refreshing data before closing:", error);
      onClose();
    }
  };

  // Map printer type from settings → URL segment
  const mapPrinterToUrlValue = (printer) => {
    if (!printer || typeof printer !== "string") return null;
    const p = printer.toLowerCase().trim();

    if (p === "thermal") return "thermal";
    if (["dotmatrix", "dot_matrix", "dot-matrix", "dot matrix"].includes(p))
      return "dotmatrix";
    if (["laser", "inkjet", "ink", "ink jet", "ink-jet"].includes(p))
      return "laser";
     if (
       ["letterhead", "letter_head", "letter-head", "letter head"].includes(p)
     )
       return "letterhead"; 

    // "default" or anything unrecognized → fall back to old behavior
    return null;
  };

   const handleInvoiceClick = async (orderData) => {
     try {
       const isPosOrder = isProductOnlyOrder;

       let printerItems = systemSettings?.printer_by_item?.items || [];

       try {
         const vendorIdForSettings = decodedData?.data?.vendor?._id;
         const fresh = await httpService.get(
           `/vendors/getOnlineProfile?vendorId=${vendorIdForSettings}`,
         );
         printerItems =
           fresh?.data?.systemSettings?.printer_by_item?.items || printerItems;
       } catch (e) {
         console.error("Failed to refresh printer settings:", e);
       }

       const targetName = isPosOrder ? "Invoice – POS" : "Invoice – Service";
       const invoiceConfig = printerItems.find(
         (item) =>
           item.name === targetName ||
           (item.name || "").toLowerCase() === targetName.toLowerCase(),
       );

       const orderItems = orderData?.order_items || orderData?.items || [];
       const orderCategories = getOrderCategories(orderItems);
       const anyEnabled = isAnyOrderCategoryEnabled(
         invoiceConfig?.categories,
         orderCategories,
       );

       const printerValue = anyEnabled
         ? mapPrinterToUrlValue(invoiceConfig?.printer)
         : null;

       if (printerValue) {
         const baseUrl = window.location.origin;
         const previewUrl = `${baseUrl}/admin/invoicePreview/${printerValue}/${orderData._id}`;
         window.open(previewUrl, "_blank", "noopener,noreferrer");
         return;
       }

       const vendorId = decodedData.data.vendor._id;
       const invoiceRes = await httpService.get(
         `/invoice/getorderinvoice?orderId=${orderData._id}&vendorId=${vendorId}`,
       );
       if (invoiceRes.status && invoiceRes.data?.invoice_url) {
         window.open(
           invoiceRes.data.invoice_url,
           "_blank",
           "noopener,noreferrer",
         );
       } else {
         toast.error("Invoice not found");
       }
     } catch (err) {
       console.error("Failed fetching invoice", err);
       toast.error("Failed to fetch invoice");
     } finally {
       setLoading(false);
     }
   };

  if (isAddonsDrawerOpen)
    return (
      <SelectAddOnsDrawer
        isOpen={isAddonsDrawerOpen}
        onClose={handleCloseAddons}
        onSave={handleSaveAddons}
        serviceCategoryId={addonsServiceCategoryId}
        petType={addonsPetType}
        petTypeId={addonsPetTypeId}
        selectedAddons={selectedAddons}
        serviceTypeName={serviceTypeName}
        drawerWidth={"lg:w-3/4"}
      />
    );

  if (isProductsDrawerOpen)
    return (
      <ProductCatalog
        isOpen={isProductsDrawerOpen}
        onClose={() => {
          setIsProductsDrawerOpen(false);
          setSelectedItemIndex(null);
        }}
        // initialCart={selectedProducts}
        onCartUpdate={handleSaveProducts}
        apiEndpoint="/vendorproduct/getAvailableInventoryProducts"
      />
    );
  if (isOtherChargesDrawerOpen)
    return (
      <OtherChargesDrawer
        isOpen={isOtherChargesDrawerOpen}
        onClose={handleCloseOtherCharges}
        onSave={handleSaveOtherCharges}
        initialCharges={otherCharges}
        drawerWidth={"lg:w-3/4"}
      />
    );

  // Don't render if not open or if another drawer is open
  if (!isOpen) return null;

  /* -------------------------------------------------------------------------- */
  // ... (all the imports and state declarations remain the same)

  /* -------------------------------------------------------------------------- */
  return (
    <>
      {/* History Drawer - Appointment or Boarding based on current items */}
      {showHistoryDrawer &&
        (appointmentList.some(
          (app) => (app.item_type || "").toLowerCase() === "boarding",
        ) ? (
          <BoardingHistoryDrawer
            isOpen={showHistoryDrawer}
            onClose={() => setShowHistoryDrawer(false)}
            clientId={clientData?._id}
            clientData={clientData}
            onReorder={(item) => {
              const editData = {
                ...item,
                service_id: item.service_id,
                vendor_pet_id: item.vendor_pet_id || item.pet_id,
                pet_id: item.vendor_pet_id || item.pet_id,
                item_type: "boarding",
                service_type_name: item.service_type_name || "Boarding",
                // Ensure we carry a service_category_type_id for matching in PetServiceCategoryDrawer
                service_category_type_id:
                  item.service_category_type_id || item.service_type_id,
                service_type_id:
                  item.service_type_id || item.service_category_type_id,
              };
              // Close history first to avoid back opening edit unintentionally
              setShowHistoryDrawer(false);
              setTimeout(() => {
                setItemData({ ...editData, _fromHistoryReorder: true });
                setDrawerEditMode(true);
                setShowPetServiceDrawer(true);
              }, 0);
            }}
          />
        ) : (
          <AppointmentHistoryDrawer
            isOpen={showHistoryDrawer}
            onClose={() => setShowHistoryDrawer(false)}
            clientId={clientData?._id}
            clientData={clientData}
            onReorder={(item) => {
              const editData = {
                ...item,
                service_id: item.service_id,
                vendor_pet_id: item.vendor_pet_id || item.pet_id,
                pet_id: item.vendor_pet_id || item.pet_id,
                item_type: item.item_type || "grooming",
                service_type_name: item.service_type_name || item.item_type,
                // Ensure we carry a service_category_type_id for matching in PetServiceCategoryDrawer
                service_category_type_id:
                  item.service_category_type_id || item.service_type_id,
                service_type_id:
                  item.service_type_id || item.service_category_type_id,
              };
              // Close history first to avoid back opening edit unintentionally
              setShowHistoryDrawer(false);
              setTimeout(() => {
                setItemData({ ...editData, _fromHistoryReorder: true });
                setDrawerEditMode(true);
                setShowPetServiceDrawer(true);
              }, 0);
            }}
          />
        ))}

      {/* Main Booking Details Drawer - Only show when other drawers are closed */}
      {!showHistoryDrawer && (
        <div
          className={`fixed inset-0 z-50 transition-all duration-300 ease-in-out ${
            isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <div
            className="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-[2px]"
            onClick={handleClose}
          />
          <div
            className={`absolute right-0 top-0 h-full w-full md:w-[90vw] lg:w-3/4 bg-white shadow-xl transform transition-transform duration-300 ease-out ${
              isOpen ? "translate-x-0" : "translate-x-full"
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modern Header with Order Number and Type next to title - UPDATED WITH X BUTTON */}
            <div className="flex justify-between items-center p-4 border-b bg-gradient-to-r from-blue-50 to-indigo-50 shadow-sm">
              <div className="flex items-center gap-3">
                <button
                  onClick={handleClose}
                  className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-white/70 transition-colors duration-200"
                >
                  <HiArrowSmLeft className="w-6 h-6 text-gray-700" />
                </button>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center">
                    <FiCalendar className="w-4 h-4 text-white" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800">
                    {mode === "update"
                      ? appointmentList.some(
                          (app) => app.item_type?.toLowerCase() === "boarding",
                        )
                        ? "Update Schedule"
                        : "Update Schedule"
                      : "Booking Details"}
                  </h2>

                  {/* Order Number and Type badges next to header text */}
                  {orderData && (
                    <div className="flex items-center gap-2">
                      {/* Order Number Badge */}
                      <OrderNumberBadge
                        orderNumber={orderData.order_number}
                        orderType={orderData.order_type}
                        onClick={() =>
                          console.log(
                            `Order #${orderData.order_number} clicked`,
                          )
                        }
                        className={`text-xs px-2.5 py-1 rounded font-semibold shadow-md hover:scale-105 border border-black`}
                      />

                      {/* Payment Status Badge */}
                      <PaymentStatusBadge
                        status={orderData.payment_status}
                        size="sm"
                        className="rounded-lg uppercase text-xs px-2.5 py-1 font-semibold shadow-md hover:scale-105 border border-black"
                      />
                      {/* Invoice Icon Button */}
                      <div className="group relative">
                        <div
                          className={`p-2 rounded-md border bg-white transition-all duration-200 shadow-sm hover:shadow-md cursor-pointer border-gray-200 hover:border-gray-400 hover:bg-gray-50`}
                          onClick={() => handleInvoiceClick(orderData)}
                        >
                          <FaFileInvoice />
                        </div>
                        <span className="absolute z-10 top-10 left-1/2 -translate-x-1/2 whitespace-nowrap bg-gray-50 text-gray-800 text-xs font-medium px-3 py-1.5 rounded-md border border-gray-200 shadow-md opacity-0 group-hover:opacity-100 transition-all duration-200 pointer-events-none">
                          Preview Performa Invoice
                          <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2.5 h-2.5 rotate-45 bg-gray-50 border-l border-t border-gray-200" />
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* X (Close) Button on the right side */}
              <button
                onClick={handleClose}
                className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 transition-colors duration-200"
                title="Close"
              >
                <FiX className="w-5 h-5 text-gray-600" />
              </button>
            </div>

            {loading && (
              <div className="absolute inset-0 z-30 flex items-center justify-center bg-white/95">
                <div className="bg-white rounded-lg p-6 flex items-center gap-3 border border-gray-200 shadow-sm">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
                  <span className="text-gray-700">
                    Loading booking details...
                  </span>
                </div>
              </div>
            )}

            {/* Content */}
            <div className="flex h-[calc(100vh-73px)] flex-col">
              {/* Content */}
              <div className="p-2 space-y-6 overflow-auto bg-gradient-to-b from-gray-50 to-white flex-1">
                <div className="transition-opacity duration-200">
                  {/* CLIENT CARD COMPONENT */}
                  <ClientCard
                    clientData={clientData}
                    onViewEnquiry={() => setShowEnquiryDrawer(true)}
                    onViewHistory={() => setShowHistoryDrawer(true)}
                  />

                  {/* PET SERVICE LIST COMPONENT */}
                  {(appointmentList.length > 0 || productList.length > 0) && (
                    <PetServiceList
                      appointments={appointmentList}
                      products={productList}
                      mode={mode}
                      // Appointment handlers
                      onEditAppointment={handleEditAppointmentFromList}
                      onDeleteAppointment={handleDeleteAppointmentFromList}
                      onStatusUpdate={handleStatusUpdate}
                      // Product handlers ✅ FIXED
                      onDeleteProduct={(appointmentIndex, productIndex) => {
                        const product =
                          appointmentList[appointmentIndex]?.products?.[
                            productIndex
                          ];

                        if (!product) return;

                        handleDeleteProductFromAppointment(
                          appointmentIndex,
                          product.product_id || product.id,
                        );
                      }}
                      onDeleteAppointmentProduct={
                        handleDeleteProductFromAppointment
                      }
                      onIncrementProductQuantity={
                        handleIncrementProductQuantity
                      }
                      onDecrementProductQuantity={
                        handleDecrementProductQuantity
                      }
                      // Addon handlers
                      onDeleteAppointmentAddon={
                        handleDeleteAddonFromAppointment
                      }
                      onDecrementAddonQuantity={handleDecrementAddonQuantity}
                      // Other charges
                      onDeleteAppointmentOtherCharge={
                        handleDeleteOtherChargeFromAppointment
                      }
                      // Form + edit handlers
                      onAppointmentFieldChange={handleAppointmentFieldChange}
                      onRoomTypeChange={handleRoomTypeChange}
                      // Data props
                      timeSlots={timeSlots}
                      employees={employees}
                      roomTypes={roomTypes}
                      boardingPriceData={boardingPriceData}
                      // State flags
                      isCancelledOrCompleted={isCancelledOrCompleted}
                      isCalculatingPrice={isCalculatingPrice}
                      isOrderCancelled={isOrderCancelled}
                      // Client + order
                      clientData={clientData}
                      orderId={orderId}
                      // Save + refresh
                      onAppointmentSaved={fetchOrderAndClient}
                      onRefreshData={() => {
                        if (refreshClients) {
                          setTimeout(async () => {
                            await refreshClients();
                          }, 100);
                        }
                        refreshCalendarData();
                      }}
                      // Drawers
                      onOpenAddons={handleOpenAddonsDrawer}
                      onOpenAddProducts={handleOpenAddProductsDrawer}
                      onOpenOtherCharges={handleOpenOtherChargesDrawer}
                      // Totals
                      calculateAppointmentProductsTotal={
                        calculateAppointmentProductsTotal
                      }
                      autoEditRefId={itemRefId}
                      onAutoEditTriggered={() => setItemRefId(null)}
                      isOrderClosed={orderData.status === "closed"}
                      itemCount={appointmentList.length + productList.length}
                      reloadOrder={fetchOrderAndClient}
                    />
                  )}

                  {/* Add Pets & Services Button - SEPARATE COMPONENT */}
                  {mode !== "update" &&
                    clientData?._id &&
                    !isOrderCancelled &&
                    !isOrderClosed &&
                    !isCancelledOrCompleted && (
                      <AddPetsServicesButton
                        onClick={handleAddPetsAndServices}
                        mode={mode}
                        disabled={isCancelledOrCompleted}
                      />
                    )}

                  {/* Notes Section - SEPARATE COMPONENT */}
                  {mode !== "update" &&
                    !isOrderCancelled &&
                    !isCancelledOrCompleted && (
                      <NotesSection
                        notes={notes}
                        setNotes={setNotes}
                        placeholder="Describe concerns, or reason for the visit..."
                        disabled={isCancelledOrCompleted}
                      />
                    )}
                </div>
              </div>

              {/* FOOTER SECTION - Added directly in drawer */}
              <div className="px-3 py-2 border-t border-gray-200 bg-white">
                {/* TOTAL SUMMARY COMPONENT */}
                {(appointmentList.length > 0 || productList.length > 0) &&
                  mode !== "update" && (
                    <>
                      <TotalsSummary
                        totals={totalSummary}
                        discount={discount}
                        // setDiscount={setDiscount}
                        orderData={totalsOrderData}
                        isOrderCancelled={isOrderCancelled}
                        isAnyAppointmentCancelled={isAnyAppointmentCancelled}
                        orderId={orderId} // Pass orderId
                        onDiscountUpdated={() => {
                          // Refresh order data when discount is updated
                          fetchOrderAndClient();
                          if (refreshClients) {
                            setTimeout(async () => {
                              await refreshClients();
                            }, 100);
                          }
                        }}
                        isProductOnlyOrder={isProductOnlyOrder}
                        isOrderClosed={
                          StatusUtils.toDisplay(orderData?.status) === "Closed"
                        }
                      />
                      <AdjustmentAmountCard
                        adjustmentAmount={adjustmentAmount}
                        onAdjustmentChange={setAdjustmentAmount}
                        adjustmentReason={adjustmentReason}
                        onAdjustmentReasonChange={setAdjustmentReason}
                        orderTotal={parseFloat(
                          orderData?.grand_total ??
                            orderData?.total_amount ??
                            0,
                        )}
                        maxAmount={parseFloat(
                          orderData?.grand_total ??
                            orderData?.total_amount ??
                            0,
                        )}
                        showSaveButton
                        onSave={handleSaveAdjustment}
                        saving={savingAdjustment}
                        savedValue={parseFloat(
                          orderData?.adjustment_amount || 0,
                        )}
                        savedReason={orderData?.adjustment_reason || ""}
                        disabled={
                          isOrderCancelled ||
                          isOrderClosed ||
                          isCancelledOrCompleted
                        }
                        className="m-1"
                      />

                      <PaymentAndInvoice
                        totals={totalSummary}
                        orderData={orderData}
                        paymentStatus={finalPaymentStatus}
                        isOrderCancelled={isOrderCancelled}
                        isAnyAppointmentCancelled={isAnyAppointmentCancelled}
                        showPaymentSection={showPaymentSection}
                        isPaymentLoading={isPaymentLoading}
                        paymentDetails={paymentDetails}
                        onPayNow={() => setShowPaymentSection(true)}
                        onBackFromPayment={handleBackFromPayment}
                        onPaymentComplete={handlePaymentComplete}
                        orderId={orderId} // Pass orderId
                        vendorId={decodedData?.data?.user?.vendor_id}
                        refreshOrderData={fetchOrderAndClient}
                      />
                    </>
                  )}

                {/* For Update Mode - UPDATED: Removed Cancel button */}
                {mode === "update" && (
                  <div className="p-4 border-t border-gray-200 bg-white shadow-lg">
                    <div className="flex justify-center gap-3">
                      {/* REMOVED: Cancel button */}
                      <button
                        onClick={handleUpdateSchedule}
                        className="flex-1 py-3 px-4 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold rounded-xl hover:from-purple-700 hover:to-indigo-700 transition-all duration-200"
                      >
                        Update Schedule
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Enquiry Drawer - Accordion style with same UI as AddAppointment */}
      {showEnquiryDrawer && (
        <>
          <EnquiryListDrawer
            setShowEnquiryDrawer={setShowEnquiryDrawer}
            clientData={clientData}
            enquiryData={enquiryData}
            loadingEnquiries={loadingEnquiries}
            expandedEnquiry={expandedEnquiry}
            setExpandedEnquiry={setExpandedEnquiry}
            handleDeleteEnquiry={handleDeleteEnquiry}
            handleProductQuantityChanges={handleProductQuantityChanges}
            handleProductQuantityInputs={handleProductQuantityInputs}
            handleSaveEnquiryBooking={handleSaveEnquiryBooking}
            handleSaveEnquiryWithPayment={handleSaveEnquiryWithPayment}
            handleEditEnquiry={handleEditEnquiryDrawer}
          />
          {showEditEnquiryDrawer && (
            <EditEnquiry
              isOpen={showEditEnquiryDrawer}
              onClose={() => {
                setShowEditEnquiryDrawer(false);
                setEditEnquiryData([]);
              }}
              onSave={(data) => {
                setShowEditEnquiryDrawer(false);
                setEditEnquiryData([]);
                setShowEnquiryDrawer(false);
                handleClose();
              }}
              appointmentStatusRef={refId}
              enquiryDetails={editEnquiryData}
              clientDetails={clientData}
            />
          )}
        </>
      )}

      {/* Enquiry Payment Section */}
      {showEnquiryPaymentSection && selectedEnquiryForPayment && (
        <div className="fixed inset-0 z-50 transition-all duration-300 ease-in-out">
          <div className="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-[2px]" />
          <div className="absolute right-0 top-0 h-full w-full lg:w-1/2 bg-white shadow-xl transform transition-transform duration-300 ease-out">
            {/* Payment Header */}
            <div className="flex justify-start items-center p-4 border-b bg-gradient-to-r from-green-50 to-emerald-50 shadow-sm gap-3">
              <button
                onClick={handleBackFromEnquiryPayment}
                className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-white/70 transition-colors duration-200"
              >
                <FiArrowLeft className="w-6 h-6 text-gray-700" />
              </button>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center">
                  <MdPayment className="w-4 h-4 text-white" />
                </div>
                <h2 className="text-xl font-semibold text-gray-800">
                  Payment Details
                </h2>
              </div>
            </div>

            {/* Payment Content */}
            <div className="flex h-[calc(100vh-73px)] flex-col">
              <div className="p-6 space-y-6 overflow-auto bg-gradient-to-b from-gray-50 to-white flex-1">
                {/* Total Amount Display */}
                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                  <div className="space-y-2">
                    {(() => {
                      const totals = calculateEnquiryTotals();
                      return (
                        <>
                          <div className="flex justify-between text-sm">
                            <span>Subtotal (excl. GST)</span>
                            <span>₹ {totals.subtotal}</span>
                          </div>
                          <div className="flex justify-between text-sm">
                            <span>GST</span>
                            <span>₹ {totals.gst}</span>
                          </div>
                          <div className="flex justify-between text-sm">
                            <span>Discount</span>
                            <span>₹ {totals.discount}</span>
                          </div>
                          <div className="flex justify-between text-lg font-bold border-t border-gray-300 pt-2">
                            <span>Total Amount</span>
                            <span>₹ {totals.total}</span>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                </div>

                {/* Payment Methods Section */}
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <h4 className="text-lg font-semibold text-gray-800">
                      Payment Methods
                    </h4>
                  </div>

                  {/* Single Payment Method */}
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Payment Type
                      </label>
                      <div className="grid grid-cols-2 gap-2">
                        <button
                          onClick={() =>
                            setPaymentDetails((prev) => ({
                              ...prev,
                              paymentType: "full",
                              amount: calculateEnquiryTotals().total,
                            }))
                          }
                          className={`p-3 border rounded-lg text-sm font-medium transition-colors ${
                            paymentDetails.paymentType === "full"
                              ? "border-blue-500 bg-blue-50 text-blue-700"
                              : "border-gray-300 hover:border-gray-400"
                          }`}
                        >
                          Full Payment
                        </button>
                        <button
                          onClick={() =>
                            setPaymentDetails((prev) => ({
                              ...prev,
                              paymentType: "partial",
                              amount: "",
                            }))
                          }
                          className={`p-3 border rounded-lg text-sm font-medium transition-colors ${
                            paymentDetails.paymentType === "partial"
                              ? "border-blue-500 bg-blue-50 text-blue-700"
                              : "border-gray-300 hover:border-gray-400"
                          }`}
                        >
                          Partial Payment
                        </button>
                      </div>
                    </div>

                    {paymentDetails.paymentType === "partial" && (
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Amount
                        </label>
                        <input
                          type="number"
                          value={paymentDetails.amount}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            const totalAmount = parseFloat(
                              calculateEnquiryTotals().total,
                            );

                            if (parseFloat(inputValue) > totalAmount) {
                              toast.error(
                                "Partial payment cannot exceed total amount",
                                {
                                  position: "top-center",
                                },
                              );
                              return;
                            }

                            setPaymentDetails((prev) => ({
                              ...prev,
                              amount: inputValue,
                            }));
                          }}
                          placeholder="Enter amount"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          max={calculateEnquiryTotals().total}
                        />
                      </div>
                    )}

                    {paymentDetails.paymentType && (
                      <>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Payment Method
                          </label>
                          <div className="grid grid-cols-3 gap-2">
                            {["cash", "upi", "credit", "cheque", "bank"].map(
                              (method) => (
                                <button
                                  key={method}
                                  onClick={() =>
                                    setPaymentDetails((prev) => ({
                                      ...prev,
                                      method,
                                    }))
                                  }
                                  className={`p-2 border rounded-lg text-sm font-medium capitalize transition-colors ${
                                    paymentDetails.method === method
                                      ? "border-blue-500 bg-blue-50 text-blue-700"
                                      : "border-gray-300 hover:border-gray-400"
                                  }`}
                                >
                                  {method === "upi" ? "UPI" : method}
                                </button>
                              ),
                            )}
                          </div>
                        </div>

                        {paymentDetails.method &&
                          paymentDetails.method !== "cash" && (
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-2">
                                Reference Number
                                {paymentDetails.method === "upi" &&
                                  " (Transaction ID)"}
                                {paymentDetails.method === "credit" &&
                                  " (Transaction ID)"}
                                {paymentDetails.method === "cheque" &&
                                  " (Cheque Number)"}
                                {paymentDetails.method === "bank" &&
                                  " (Transaction ID)"}
                              </label>
                              <input
                                type="text"
                                value={paymentDetails.reference}
                                onChange={(e) =>
                                  setPaymentDetails((prev) => ({
                                    ...prev,
                                    reference: e.target.value,
                                  }))
                                }
                                placeholder={`Enter ${paymentDetails.method} reference`}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                              />
                            </div>
                          )}

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Notes (Optional)
                          </label>
                          <textarea
                            value={paymentDetails.notes}
                            onChange={(e) =>
                              setPaymentDetails((prev) => ({
                                ...prev,
                                notes: e.target.value,
                              }))
                            }
                            placeholder="Payment notes..."
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            rows={2}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Payment Footer */}
              <div className="p-4 border-t border-gray-200 bg-white">
                <div className="flex gap-3">
                  <button
                    onClick={handleBackFromEnquiryPayment}
                    className="flex-1 py-3 px-4 bg-gray-600 text-white font-semibold rounded-xl hover:bg-gray-700 transition-colors duration-200 flex items-center justify-center gap-2"
                  >
                    <FiArrowLeft className="w-4 h-4" />
                    Back
                  </button>
                  <button
                    onClick={() => handleEnquiryPaymentComplete(paymentDetails)}
                    disabled={!paymentDetails.method || isPaymentLoading}
                    className="flex-1 py-3 px-4 bg-gradient-to-r from-green-600 to-emerald-600 text-white font-semibold rounded-xl hover:from-green-700 hover:to-emerald-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  >
                    {isPaymentLoading ? (
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    ) : (
                      <FiCheck className="w-4 h-4" />
                    )}
                    Complete Payment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showPetServiceDrawer && (
        <PetServiceCategoryDrawer
          isOpen={showPetServiceDrawer}
          onClose={() => {
            setShowPetServiceDrawer(false);
            setItemData([]);
            setDrawerEditMode(false);
          }}
          onUpdate={fetchOrderAndClient}
          clientId={clientData?._id}
          clientName={`${clientData?.first_name || ""} ${clientData?.last_name || ""}`.trim()}
          clientNumber={clientData?.phone || ""}
          itemData={itemData}
          orderId={orderId}
          fromCalendar={false}
          editMode={drawerEditMode}
          onRefreshData={() => {
            if (refreshClients) {
              setTimeout(async () => {
                await refreshClients();
              }, 100);
            }
            refreshCalendarData();
          }}
          isServiceEditMode={drawerEditMode}
          isPetDetails={false}
          drawerWidth="lg:w-3/4"
        />
      )}
    </>
  );
};;

export default BookingDetailsDrawer;
